import request, { exportFile, importFile } from './index';

// 财务模块前缀 此常量存储财务模块的 URL 前缀
export const FINANCIAL_MODULE_PREFIX = '/route/finance/web/';

export const USER_MODULE_PREFIX = '/route/user/web/'; // 用户模块路由的前缀。
export const STATION_MODULE_PREFIX = '/route/station/web/'; // 用户模块路由的前缀。
export const USER_MODULE_UPLOAD_PREFIX = '/upRoute/user/web/'; // 用户模块路由的前缀。

export const FILE_UPLOAD_GATEWAY = '/upRoute/'; // 文件上传网关
export const FINANCIAL_MODULE_FILE_UPLOAD_PREFIX = `${FILE_UPLOAD_GATEWAY}finance/web/`; // 财务模块路由文件上传的前缀。

export const OPERATION_USER_DENY_PREFIX = '/poly/web/user/'; // 运营商黑名单前缀
export const OM_MANAGEMENT_PREFIX = '/route/device/web/'; // 运维管理模块前缀
export const RECONCILIATION_MANAGEMENT_PREFIX = '/route/statistics/web/'; // 对账管理模块前缀
export const POLY_FINANCIAL_PREFIX = '/poly/web/finance/'; // 基础 POLY 财务服务
export const POLY_MONITOR_PREFIX = '/poly/web/monitor/'; // 基础 POLY 监控服务
export const STATION_WEB_PREFIX = '/route/station/web/'; // 电站 WEB 前缀
export const UP_ROUTE_SUPPORT_PREFIX = '/upRoute/support/web/'; // 上传钩子前缀

/** 密码修改-管理员登录后修改自己的密码 */
export const updatePassword = (data = {}) => {
  return request({
    // url: '/user/web/account/password/update',
    url: '/route/user/web/account/password/update',
    data,
  });
};

/** 数据字典模块接口服务 */
export const dict = {
  /** 根据key数组获取字典 */
  // eslint-disable-next-line
  getDictionaryByKeys: body => {
    return Promise.resolve({ body: [] });
    // if (!Array.isArray(body) || body.length === 0) {
    //   throw new Error('参数必须是长度大于1的字符串数组');
    // }
    // return request({
    //   url: '/IopStationAuthServer/dict/getDict',
    //   data: { body },
    // });
  },
};

/** 网点标准采购价 */
export const purchasePriceStandard = {
  /** 网点标准采购价批量导入 */
  import: data => {
    return importFile({
      url: `/priceCenterServer/purchasePriceStandard/file/upload/batchImport`,
      data,
    });
  },
  /** 网点标准采购价详情 */
  detail: body => {
    return request({
      url: `/priceCenterServer/purchasePriceStandard/detail`,
      data: { body },
    });
  },
};

/** 运营管理 */
export const orgMatchPushRule = {
  /** 运营管理停用 */
  stop: body => {
    return request({
      url: `/IopStationAuthServer/orgMatchPushRule/stop`,
      data: { body },
    });
  },

  /** 运营管理分页查询/即将到期 */
  page: data => {
    return request({
      url: `/IopStationAuthServer/orgMatchPushRule/page`,
      data,
    });
  },

  /** 运营管理即将到期计数 */
  countExpire: body => {
    return request({
      url: `/IopStationAuthServer/orgMatchPushRule/countExpire`,
      data: { body },
    });
  },

  /** 运营管理名称查重 */
  checkName: body => {
    return request({
      url: `/IopStationAuthServer/orgMatchPushRule/checkName`,
      data: { body },
    });
  },

  /** 运营管理导出 */
  export: (fileName, body) => {
    return exportFile({
      url: `/IopStationAuthServer/orgMatchPushRule/export`,
      data: { body },
      fileName,
    });
  },

  /** 运营管理批量停用 */
  batchStop: body => {
    return request({
      url: `/IopStationAuthServer/orgMatchPushRule/batchStop`,
      data: { body },
    });
  },

  /** 运营管理批量导入 */
  upload: data => {
    return importFile({
      url: `/IopStationAuthServer/orgMatchPushRule/upload`,
      data,
    });
  },

  /** 运营管理新增 */
  add: body => {
    return request({
      url: `/IopStationAuthServer/orgMatchPushRule/add`,
      data: { body },
    });
  },

  /** 运营管理机构下拉框 */
  getFleets: body => {
    return request({
      url: `/IopStationAuthServer/orgMatchPushRule/getOrg`,
      data: { body },
    });
  },

  /** 运营管理电站树 */
  station_tree: body => {
    return request({
      url: `/IopStationAuthServer/orgMatchPushRule/station/tree`,
      data: { body },
    });
  },

  /** 运营管理站点配置导入 */
  station_upload: data => {
    return importFile({
      url: `/IopStationAuthServer/orgMatchPushRule/station/upload`,
      data,
    });
  },

  /** 运营管理编辑 */
  edit: body => {
    return request({
      url: `/IopStationAuthServer/orgMatchPushRule/edit`,
      data: { body },
    });
  },

  /** 运营管理详情 */
  detail: body => {
    return request({
      url: `/IopStationAuthServer/orgMatchPushRule/detail`,
      data: { body },
    });
  },
};

/** 佣金申请模块接口服务 */
export const commission = {
  /** 佣金申请列表 */
  list: data => {
    return request({
      url: `/IopStationAuthServer/commission/list`,
      data,
    });
  },
  /** 佣金申请列表导出 */
  export: (fileName, body) => {
    return exportFile({
      url: `/IopStationAuthServer/commission/list/export`,
      data: { body },
      fileName,
    });
  },
  /** 佣金申请详情 */
  detail: body => {
    return request({
      url: `/IopStationAuthServer/commission/detail`,
      data: { body },
    });
  },
  /** 佣金申请编辑 */
  update: body => {
    return request({
      url: `/IopStationAuthServer/commission/update`,
      data: { body },
    });
  },
  /** 佣金列表页聚合信息 */
  polymerization: body => {
    return request({
      url: `/IopStationAuthServer/commission/polymerization`,
      data: { body },
    });
  },
};

/**
 * 客户司机
 */
export const customerUser = {
  // 客户司机分页
  queryCompanyUserPageList: data => {
    return request({
      url: '/poly/web/user/queryCompanyUserPageList',
      data,
    });
  },
  // C端司机分页
  queryUserPageList: data => {
    return request({
      url: '/route/user/web/charge/user/page',
      data,
    });
  },
  // 客户司机新增
  add: data => {
    return request({
      url: '/poly/web/user/createUser',
      data,
    });
  },
  // 客户司机详情
  detail: data => {
    return request({
      url: '/route/user/web/charge/user/detail',
      data,
    });
  },
  // 客户司机编辑
  edit: data => {
    return request({
      url: '/poly/web/user/updateUser',
      data,
    });
  },
  // 司机账号删除
  chargeUserDelete: data => {
    return request({
      url: '/route/user/web/chargeUser/delete',
      data,
    });
  },
  // 充电司机分页查询
  chargeUserPage: data => {
    return request({
      url: '/route/user/web/charge/user/page',
      data,
    });
  },
  // 充电司机账号（启/停）用
  changeStatus: data => {
    return request({
      url: '/poly/web/user/status/switch',
      data,
    });
  },
  // 司机账号 启用停用
  changeUserStatus: data => {
    return request({
      url: '/route/user/web/chargeUser/changeStatus',
      data,
    });
  },
  // 客户司机 密码修改
  updatePwd: data => {
    return request({
      url: '/route/user/web/chargeUser/updatePwd',
      data,
    });
  },
  // 司机详情 》 绑定车辆记录分页查询
  bindCarPage: data => {
    return request({
      url: '/route/user/web/user/car/bind/record/page',
      data,
    });
  },
  // 司机详情 》 支付分签约历史记录
  signHistoryPage: data => {
    return request({
      url: '/route/finance/web/sign/notify/page',
      data,
    });
  },
};

/**
 * 客户机构
 */
export const customerOrg = {
  // 归属机构 下拉框查询条件专用
  queryOrg: data => {
    return request({
      url: '/route/user/web/customer/org/list',
      data,
    });
  },
  // 机构下拉框列表-预约单和占位单查询条件用
  sourceList: data => {
    return request({
      url: '/route/user/web/customer/org/source/list',
      data,
    });
  },
  // 客户机构分页
  list: data => {
    return request({
      url: '/route/user/web/customer/org/page',
      data,
    });
  },
  // 客户机构新增
  add: data => {
    return request({
      url: '/route/user/web/customer/org/add',
      data,
    });
  },

  // 客户机构编辑
  edit: data => {
    return request({
      url: '/route/user/web/customer/org/update',
      data,
    });
  },
  // 单个添加的方式绑定司机账号
  bindDriver: data => {
    return request({
      url: '/route/user/web/customer/org/driver/bind',
      data,
    });
  },
  // 客户机构详情
  detail: data => {
    return request({
      url: '/route/user/web/customer/org/detail',
      data,
    });
  },
  // 客户机构详情页-绑定的充电司机分页查询
  driverList: data => {
    return request({
      url: '/route/user/web/customer/org/driver/page',
      data,
    });
  },
  // 客户机构详情页-移除绑定的充电司机
  removeDriver: data => {
    return request({
      url: '/route/user/web/customer/org/driver/delete',
      data,
    });
  },
  // 内部公司列表查询条件-主机构下拉框
  queryCompanyMainOrgList: data => {
    return request({
      url: '/route/user/web/org/queryCompanyMainOrgList',
      data,
    });
  },
  // 客户机构 所有机构下拉列表
  queryMainOrgWithOutZdlList: data => {
    return request({
      url: '/route/user/web/org/queryMainOrgWithOutZdlList',
      data,
    });
  },
  // 子公司管理列表-所有下拉框
  queryCompanyAllOrgList: data => {
    return request({
      url: '/route/user/web/org/queryCompanyAllOrgList',
      data,
    });
  },
  // 子机构司机名称验重
  checkUserAccountRepeat: data => {
    return request({
      url: '/route/user/web/chargeUser/checkUserAccountRepeat',
      data,
    });
  },
  // 互联互通客户-校验机构名与机构代码是否重复
  checkOrgRepeat: data => {
    return request({
      url: '/route/user/web/connectivity/org/check',
      data,
    });
  },
  // 客户机构导入
  importOrg: data => {
    return request({
      url: '/upRoute/user/web/customer/org/driver/import',
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      data,
    });
  },
  // 内部公司批量导入
  importInternalOrg: data => {
    return request({
      url: '/upRoute/user/web/org/importCompanyOrg',
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      data,
    });
  },

  // 客户司机批量导入
  importOrgUser: data => {
    return request({
      url: '/upRoute/user/web/chargeUser/importOrgUser',
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      data,
    });
  },
  // 内部司机批量导入
  importCompanyUser: data => {
    return request({
      url: '/upRoute/user/web/chargeUser/importCompanyUser',
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      data,
    });
  },
  // 客户车辆批量导入
  importOrgCar: data => {
    return request({
      url: '/upRoute/user/web/car/importOrgCar',
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      data,
    });
  },
  // 内部车辆批量导入
  importCompanyCar: data => {
    return request({
      url: '/upRoute/user/web/car/importCompanyCar',
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      data,
    });
  },
  // 车辆批量删除
  batchDelCarByIds: data => {
    return request({
      url: '/route/user/web/car/batchDelCarByIds',
      data,
    });
  },
};

/**
 * 客户司机 账户
 */
export const CustomDriverAccounts = {
  // 列表接口
  list: data => {
    return request({
      url: `${FINANCIAL_MODULE_PREFIX}account/manage/customer/driver/customerDriverList`,
      data,
    });
  },
  // 导出接口 -- 列表页
  export: (fileName, body) => {
    return exportFile({
      url: `${FINANCIAL_MODULE_PREFIX}account/manage/customer/driver/customerDriverList/export`,
      data: { body },
      fileName,
    });
  },
  // 导出接口 -- 详情页 流水列表
  exportOfFlowList: (fileName, body) => {
    return exportFile({
      url: `${FINANCIAL_MODULE_PREFIX}account/manage/customer/driver/flowList/export`,
      data: { body },
      fileName,
    });
  },
  // 客户账户 头部信息 -- 详情页
  detailHeaderInfo: data => {
    return request({
      url: `${FINANCIAL_MODULE_PREFIX}account/manage/customer/driver/header`,
      data,
    });
  },
  // 客户账户 流水列表 -- 详情页
  flowList: data => {
    return request({
      url: `${FINANCIAL_MODULE_PREFIX}account/manage/customer/driver/flowList`,
      data,
    });
  },
};

/**
 * 客户车辆
 */
export const customerVehicle = {
  // 充电客户-会员车辆认证
  list: data => {
    return request({
      url: '/route/user/web/user/car/page',
      data,
    });
  },
  // 充电客户-会员车辆认证详情
  detail: data => {
    return request({
      url: '/route/user/web/user/car/detail',
      data,
    });
  },
  // 客户车辆增加
  add: data => {
    return request({
      url: '/route/user/web/car/add',
      data,
    });
  },
  // 客户车辆编辑
  edit: data => {
    return request({
      url: '/route/user/web/car/update',
      data,
    });
  },

  // 客户车辆绑定账号
  bindUser: data => {
    return request({
      url: '/route/user/web/car/bindUser',
      data,
    });
  },
  // 获取用户列表
  queryAllUserByOrgId: data => {
    return request({
      url: '/route/user/web/chargeUser/queryAllUserByOrgId',
      data,
    });
  },
  // 车辆验重
  checkPlateNumberByMainOrgId: data => {
    return request({
      url: '/route/user/web/car/checkPlateNumberByMainOrgId',
      data,
    });
  },
};

/**
 * @description C端司机账户
 */
export const cSideDriverAccount = {
  // 列表接口
  list: data => {
    return request({
      url: `${FINANCIAL_MODULE_PREFIX}account/manage/client/driver/list`,
      data,
    });
  },
  // 导出接口 -- 列表页
  export: (fileName, body) => {
    return exportFile({
      url: `${FINANCIAL_MODULE_PREFIX}account/manage/client/driver/list/export`,
      data: { body },
      fileName,
    });
  },
  // 导出接口 -- C端司机账户详情页的流水列表
  exportOfFlowList: (fileName, body) => {
    return exportFile({
      url: `${FINANCIAL_MODULE_PREFIX}account/manage/client/driver/flowList/export`,
      data: { body },
      fileName,
    });
  },
  // C端司机账户详情 - 头部信息
  detailHeaderInfo: data => {
    return request({
      url: `${FINANCIAL_MODULE_PREFIX}account/manage/client/driver/header`,
      data,
    });
  },
  // C端司机账户详情 - 流水列表
  flowList: data => {
    return request({
      url: `${FINANCIAL_MODULE_PREFIX}account/manage/client/driver/flowList`,
      data,
    });
  },
  //   第三方支付账户
  //   third/queryPayRefundRecordForPage
  queryPayRefundRecordForPage: data => {
    return request({
      url: `${FINANCIAL_MODULE_PREFIX}third/queryPayRefundRecordForPage`,
      data,
    });
  },
};

//  账户管理 客户账户
export const customerAccount = {
  // 列表接口
  list: data => {
    return request({
      url: `/route/finance/web/account/manage/customer/list`,
      data,
    });
  },
  // 导出接口 -- 列表页
  export: (fileName, body) => {
    return exportFile({
      url: `${FINANCIAL_MODULE_PREFIX}account/manage/customer/customerList/export`,
      data: { body },
      fileName,
    });
  },
  // 导出接口 -- 详情页 流水列表
  exportOfFlowList: (fileName, body) => {
    return exportFile({
      url: `${FINANCIAL_MODULE_PREFIX}account/manage/customer/detail/export`,
      data: { body },
      fileName,
    });
  },
  // 客户账户 头部信息 -- 详情页
  detailHeaderInfo: data => {
    return request({
      url: `/route/finance/web/account/manage/customer/header/detail`,
      data,
    });
  },
  // 客户账户 流水列表 -- 详情页
  flowList: data => {
    return request({
      url: `/route/finance/web/account/manage/customer/flow/list`,
      data,
    });
  },
  //   分配或扣回
  allocateOrTakeBack: data => {
    return request({
      url: `/route/finance/web/account/manage/customer/batchAllocationOrTakeBack`,
      data,
    });
  },
  //   充值或扣款
  rechargeOrDeduction: data => {
    return request({
      url: `/route/finance/web/account/manage/customer/adjustmentWallet`,
      data,
    });
  }, //   充值或扣款 互联互通账户
  interconnectedRechargeOrDeduction: data => {
    return request({
      url: `/route/finance/web/account/manage/interconnection/adjustmentWallet`,
      data,
    });
  },
  //   导入分配扣回信息
  importDistributionDeduction: data => {
    return request({
      url: `${FINANCIAL_MODULE_FILE_UPLOAD_PREFIX}account/manage/customer/importAllocationOrTakeBack`,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      data,
    });
  },
  //   选择对象，查询对象下的子机构和用户
  queryUserAndOrgInfo4Finance: data => {
    return request({
      url: `/route/user/web/customer/org/child/org/balance/list`,
      data,
    });
  },
};

/**
 * 互联互通客户
 */
export const unioneOrg = {
  // 互联互通客户列表
  list: data => {
    return request({
      url: '/route/user/web/connectivity/org/page',
      data,
    });
  },
  // 互联互通客户-查询推送配置默认配置项
  queryPushConfig: data => {
    return request({
      url: '/route/user/web/connectivity/org/defaultConfig/detail',
      data,
    });
  },
  // 互联互通客户-互联客户修改
  edit: data => {
    return request({
      url: '/route/user/web/connectivity/org/update',
      data,
    });
  },
  // 互联互通客户详情
  detail: data => {
    return request({
      url: '/route/user/web/connectivity/org/detail',
      data,
    });
  },
  // 互联互通客户-互联客户新增
  add: data => {
    return request({
      url: '/route/user/web/connectivity/org/add',
      data,
    });
  },
  // 互联互通站点推送详情
  zdlDetail: data => {
    return request({
      url: '/route/user/web/connectivity/secret/pushConfig/detail',
      data,
    });
  },
  // 互联互通站点推送编辑
  zdlEdit: data => {
    return request({
      url: '/upNotRoute/user/web/connectivity/secret/pushConfig/update',
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      data,
    });
  },
};

/**
 * @description 账户管理 互联互通账户
 */
export const interconnectedAccounts = {
  // 互联互通账户》客户列表
  list: data => {
    return request({
      url: `/route/finance/web/account/manage/interconnection/list`,
      data,
    });
  },
  // 导出接口 -- 列表页
  export: (fileName, body) => {
    return exportFile({
      url: `${FINANCIAL_MODULE_PREFIX}account/manage/interconnection/list/export`,
      data: { body },
      fileName,
    });
  },
  // 导出接口 -- 详情页 流水列表
  exportOfFlowList: (fileName, body) => {
    return exportFile({
      url: `${FINANCIAL_MODULE_PREFIX}account/manage/interconnection/flowList/export`,
      data: { body },
      fileName,
    });
  },
  // 客户账户 头部信息 -- 详情页
  detailHeaderInfo: data => {
    return request({
      url: `/route/finance/web/account/manage/interconnection/header/detail`,
      data,
    });
  },
  // 互联互通账户流水
  flowList: data => {
    return request({
      url: `/route/finance/web/account/manage/interconnection/flow/list`,
      data,
    });
  },
};

/**
 * @description 财务管理 发票管理
 */
export const invoiceManagements = {
  // 发票作废（冲红）
  redInvoice: data => {
    return request({
      url: `/route/finance/web/invoice/redInvoice`,
      data,
    });
  },

  //  获取开票申请列表
  list: data => {
    return request({
      url: `/route/finance/web/invoice/list`,
      data,
    });
  },
  // 发票申请详情
  detail: data => {
    return request({
      url: `/route/finance/web/invoice/detail`,
      data,
    });
  },
  // 驳回
  // POST invoice/manage/cancelInvoice
  // 接口ID：65109394
  // 接口地址：https://www.apifox.cn/web/project/2248392/apis/api-65109394
  doReject: data => {
    return request({
      url: `${FINANCIAL_MODULE_PREFIX}invoice/manage/cancelInvoice`,
      data,
    });
  },
  // 退回
  // POST invoice/manage/backInvoice
  // 接口ID：65110319
  // 接口地址：https://www.apifox.cn/web/project/2248392/apis/api-65110319
  doReturn: data => {
    return request({
      url: `${FINANCIAL_MODULE_PREFIX}invoice/manage/backInvoice`,
      data,
    });
  },
  // 开票申请 -- B端
  // B端申请开票
  // POST /omp/poly/web/finance/invoice/invoiceApply
  // 接口ID：71445675
  // 接口地址：https://www.apifox.cn/web/project/2248392/apis/api-71445675
  doBSideApply: data => {
    return request({
      url: `${POLY_FINANCIAL_PREFIX}invoice/invoiceApply`,
      data,
    });
  },
  // 获取B端开票金额 -- B端
  // POST /omp/poly/web/finance/invoice/getApplyAmount
  // 接口ID：71444779
  // 接口地址：https://www.apifox.cn/web/project/2248392/apis/api-71444779
  getBSideApplyAmount: data => {
    return request({
      url: `${POLY_FINANCIAL_PREFIX}invoice/getApplyAmount`,
      data,
    });
  },
  // 导出接口 -- 列表页
  export: (fileName, body) => {
    return exportFile({
      url: `${FINANCIAL_MODULE_PREFIX}account/manage/interconnection/list/export`,
      data: { body },
      fileName,
    });
  },
  // 确认提交开票申请
  confirmInvoice: data => {
    return request({
      url: `${FINANCIAL_MODULE_PREFIX}invoice/manage/confirmInvoice`,
      data,
    });
  },
};

// 互联互通秘钥
export const cipherUnione = {
  // 秘钥列表
  list: data => {
    return request({
      url: '/route/user/web/connectivity/secret/page',
      data,
    });
  },
  // 互联互通客户-互联秘钥新增
  add: data => {
    return request({
      url: '/route/user/web/connectivity/secret/add',
      data,
    });
  },
  // 互联互通客户-互联秘钥删除
  delete: data => {
    return request({
      url: '/route/user/web/connectivity/secret/delete',
      data,
    });
  },
  // 互联互通客户-互联秘钥修改
  edit: data => {
    return request({
      url: '/route/user/web/connectivity/secret/update',
      data,
    });
  },
  // 互联互通客户-互联秘钥详情
  detail: data => {
    return request({
      url: '/route/user/web/connectivity/secret/detail',
      data,
    });
  },
  // 互联互通客户-互联机构名称下拉框
  zdlOrgList: data => {
    return request({
      url: '/route/user/web/connectivity/org/list',
      data,
    });
  },
};

/**
 * @description 运营管理-充电计费信息【充电价格策略、充电价格模版】
 */
export const chargeStrategy = {
  // 根据 ’充电价格策略id‘  获取  充电价格策略
  getStrategy: data => {
    return request({
      url: `/route/station/web/station/price/strategy/simple/detail`,
      data,
    });
  },
  /** 【充电价格策略】-分页查询 */
  queryForPage: data => {
    return request({
      notShowError: false,
      url: `/route/station/web/station/price/strategy/page`,
      data,
    });
  },
  /** 【充电价格策略】-编辑 */
  edit: data => {
    return request({
      url: `/route/station/web/station/price/strategy/batch/update`,
      data,
    });
  },
  /** 【充电价格策略】-详情 */
  detail: data => {
    return request({
      url: `/route/station/web/station/price/strategy/detail`,
      data,
    });
  },
  /** 【充电价格策略】-详情-价格编辑记录 */
  history: data => {
    return request({
      url: `/route/station/web/station/price/strategy/history/page`,
      data,
    });
  },
  /** 【充电价格策略】-详情-价格编辑记录-详情 */
  historyDetail: data => {
    return request({
      url: `/route/station/web/station/price/strategy/history/detail`,
      data,
    });
  },
  /** 【充电价格模板】-分页查询 */
  chargePriceTemplateQuery: data => {
    return request({
      notShowError: false,
      url: `/route/station/web/price/template/page`,
      data,
    });
  },
  /** 【充电价格模板】-编辑 */
  chargePriceTemplateEdit: data => {
    return request({
      notShowError: false,
      url: `/route/station/web/price/template/update`,
      data,
    });
  },
  /** 【充电价格模板】-新增 */
  chargePriceTemplateAdd: data => {
    return request({
      notShowError: false,
      url: `/route/station/web/price/template/add`,
      data,
    });
  },
  /** 【充电价格模板】-删除 */
  chargePriceTemplateDelete: data => {
    return request({
      notShowError: false,
      url: `/route/station/web/price/template/delete`,
      data,
    });
  },
  /** 【充电价格模板】-详情（编辑回显） */
  chargePriceTemplateDetail: data => {
    return request({
      notShowError: false,
      url: `/route/station/web/price/template/detail`,
      data,
    });
  },
  /** 【充电价格模板】-模板定时价格详情 */
  chargePriceTemplateTimingDetail: data => {
    return request({
      notShowError: false,
      url: `/route/station/web/price/template/timing/detail`,
      data,
    });
  },
  /** 【充电价格模板】-编辑记录 */
  chargePriceTemplateHistoryPage: data => {
    return request({
      notShowError: false,
      url: `/route/station/web/price/template/history/page`,
      data,
    });
  },
  /** 【充电价格模板】-编辑记录详情 */
  chargePriceTemplateHistoryDetail: data => {
    return request({
      notShowError: false,
      url: `/route/station/web/price/template/history/detail`,
      data,
    });
  },
  /** 【充电价格模板】-关联站点列表 */
  chargePriceTemplateStationPage: data => {
    return request({
      notShowError: false,
      url: `/route/station/web/price/template/station/page`,
      data,
    });
  },
  /** 【充电价格模板】-模板定时配置-新增 */
  chargePriceTemplateTimingAdd: data => {
    return request({
      notShowError: false,
      url: `/route/station/web/price/template/timing/add`,
      data,
    });
  },
  /** 【充电价格模板】-模板定时配置-取消 */
  chargePriceTemplateTimingCancel: data => {
    return request({
      notShowError: false,
      url: `/route/station/web/price/template/timing/cancel`,
      data,
    });
  },
  /** 【充电价格模板】-查询(全量数据-下拉列表) */
  chargePriceTemplateQueryAll: data => {
    return request({
      notShowError: false,
      url: `/route/station/web/price/template/list`,
      data,
    });
  },
};

/**
 * @description 运营管理-占位计费信息【占位价格策略、占位价格模版】
 */
export const occupyStrategy = {
  /** 【占位价格策略】-分页查询 */
  queryForPage: data => {
    return request({
      url: `/route/station/web/station/occupy/strategy/page`,
      data,
    });
  },
  /** 【占位价格策略】-详情 */
  detail: data => {
    return request({
      url: `/route/station/web/station/occupy/strategy/detail`,
      data,
    });
  },
  /** 【占位价格策略】-新增 */
  add: data => {
    return request({
      url: `/route/station/web/station/occupy/price/strategy/batch/add`,
      data,
    });
  },
  /** 【占位价格模版】-模版全量查询 */
  chargePriceTemplateQueryAll: data => {
    return request({
      notShowError: false,
      url: `/route/station/web/occupy/price/template/list`,
      data,
    });
  },
  /** 【占位价格模版】-详情-分页查询绑定的场站 */
  chargePriceTemplateRelatedStationPage: data => {
    return request({
      notShowError: false,
      url: `/route/station/web/occupy/price/template/relatedStation/page`,
      data,
    });
  },
  /** 【占位价格模版】-分页查询 */
  templateQueryPage: data => {
    return request({
      url: `/route/station/web/occupy/price/template/page`,
      data,
    });
  },
  /** 【占位价格模版】-新增 */
  templateAdd: data => {
    return request({
      url: `/route/station/web/occupy/price/template/add`,
      data,
    });
  },
  /** 【占位价格模版】-编辑 */
  templateEdit: data => {
    return request({
      url: `/route/station/web/occupy/price/template/update`,
      data,
    });
  },
  /** 【占位价格模版】-删除 */
  templateDelete: data => {
    return request({
      url: `/route/station/web/occupy/price/template/delete`,
      data,
    });
  },
  /** 【占位价格模版】-详情 */
  templateDetail: data => {
    return request({
      url: `/route/station/web/occupy/price/template/detail`,
      data,
    });
  },
  /**
   *
   * 【占位豁免策略】-分页查询
   */
  exemptionList: data => {
    return request({
      url: `/route/station/web/occupy/exemption/strategy/page`,
      data,
    });
  },
  /**
   *
   * 【占位豁免策略】-新增
   */
  exemptionAdd: data => {
    return request({
      url: `/route/station/web/occupy/exemption/strategy/add`,
      data,
    });
  },
  /** 【占位豁免策略】- 品牌列表 */
  exemptionBrandList: data => {
    return request({
      url: `/route/station/web/occupy/exemption/vehicleBrand/query`,
      data,
    });
  },
  /**
   *
   *【占位豁免策略】-详情
   */
  exemptionDetail: data => {
    return request({
      url: `/route/station/web/occupy/exemption/strategy/detail`,
      data,
    });
  },
  /**
   *
   *【占位豁免策略】-删除
   */
  exemptionDelete: data => {
    return request({
      url: `/route/station/web/occupy/exemption/strategy/delete`,
      data,
    });
  },
  /**
   *
   * 【占位豁免策略】- 绑定场站
   */
  exemptionBindStation: data => {
    return request({
      url: `/route/station/web/occupy/exemption/relatedStation/bind`,
      data,
    });
  },
  /**
   *
   * 【占位豁免策略】- 解绑场站
   */
  exemptionUnBindStation: data => {
    return request({
      url: `/route/station/web/occupy/exemption/relatedStation/delete`,
      data,
    });
  },

  /**
   *
   * 【占位豁免策略】- 批量绑定
   */
  exemptionBatchBind: data => {
    return request({
      url: `${FILE_UPLOAD_GATEWAY}station/web/occupy/exemption/relatedStation/import`,
      data,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
  /**
   *
   * 【占位豁免策略】- 批量解绑
   */
  exemptionBatchUnBind: data => {
    return request({
      url: `${FILE_UPLOAD_GATEWAY}station/web/occupy/exemption/relatedStation/unbind/import`,
      data,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },

  /**
   *
   * 【占位豁免策略】- 场站列表
   */
  exemptionStationList: data => {
    return request({
      url: `/route/station/web/occupy/exemption/relatedStation/page`,
      data,
    });
  },
};

/**
 * @description 运营管理-预约策略管理【预约策略管理、预约策略模版】
 */
export const commissionStrategy = {
  /** 【预约策略管理】分页查询 */
  queryForPage: data => {
    return request({
      url: `/route/station/web/station/reserve/strategy/page`,
      data,
    });
  },
  /** 【预约策略管理】-保存 */
  save: data => {
    return request({
      url: `/route/station/web/station/reserve/strategy/batch/add`,
      data,
    });
  },
  /** 【预约策略管理】-详情 */
  detail: data => {
    return request({
      url: `/route/station/web/station/reserve/strategy/detail`,
      data,
    });
  },
  /** 【预约策略模版】分页查询 */
  templateQueryPage: data => {
    return request({
      url: `/route/station/web/reserve/template/page`,
      data,
    });
  },
  /** 【预约策略模版】-查询所有模板名称（下拉组件使用） */
  templateQueryPageAll: data => {
    return request({
      url: `/route/station/web/reserve/template/list`,
      data,
    });
  },
  /** 【预约策略模版】-新增 */
  templateQueryAdd: data => {
    return request({
      url: `/route/station/web/reserve/template/add`,
      data,
    });
  },
  /** 【预约策略模版】-编辑 */
  templateQueryEdit: data => {
    return request({
      url: `/route/station/web/reserve/template/update`,
      data,
    });
  },
  /** 【预约策略模版】-详情 */
  templateQueryDetail: data => {
    return request({
      url: `/route/station/web/reserve/template/detail`,
      data,
    });
  },
  /** 【预约策略模版】-删除 */
  templateQueryDelete: data => {
    return request({
      url: `/route/station/web/reserve/template/delete`,
      data,
    });
  },
};

/**
 * @description 运营管理-运营配置【抽成费用策略】
 */
export const operationConfiguration = {
  /** 【抽成费用策略】分页查询 */
  queryForPage: data => {
    return request({
      url: `/route/station/web/config/percentage/page`,
      data,
    });
  },
  /** 【抽成费用策略】单个/批量设置 */
  commissionSave: data => {
    return request({
      url: `/route/station/web/config/percentage/update`,
      data,
    });
  },
  /** 【抽成费用策略】详情 */
  commissionDetail: data => {
    return request({
      url: `/route/station/web/config/percentage/detail`,
      data,
    });
  },
};

/**
 * @description 运营管理-运营配置【场站-黑名单、白名单】
 */
export const operationConfigBw = {
  /** 分页查询 */
  bwPageList: data => {
    return request({
      url: `/route/station/web/config/bw/page`,
      data,
    });
  },
  /** 基础信息 */
  bwDeailInfo: data => {
    return request({
      url: `/route/station/web/config/bw/detail`,
      data,
    });
  },
  /** 添加账号 */
  bwAdd: data => {
    return request({
      url: `/route/station/web/config/bw/add`,
      data,
    });
  },
  /** 启用/禁用 */
  bwUpdateStatus: data => {
    return request({
      url: `/route/station/web/config/bw/update`,
      data,
    });
  },
  /** 移除 */
  bwUpdateRemove: data => {
    return request({
      url: `/route/station/web/config/bw/management/delete`,
      data,
    });
  },
};

/**
 * @description 运营管理-电站评价【电站评价】
 */
export const operatioStationEvaluate = {
  /** 【电站评价】分页查询 */
  evaluateList: data => {
    return request({
      url: `/route/station/web/evaluate/page`,
      data,
    });
  },
  /** 【电站评价】添加评论 */
  evaluateAdd: data => {
    return request({
      url: `/route/station/web/station/evaluate/add`,
      data,
    });
  },
  /** 【电站评价】显示/隐藏 */
  evaluateUpdateStatus: data => {
    return request({
      url: `/route/station/web/evaluate/update`,
      data,
    });
  },
  /** 【电站评价】删除 */
  evaluateDelete: data => {
    return request({
      url: `/route/station/web/station/evaluate/delete`,
      data,
    });
  },
  /** 【电站评价】详情 */
  evaluateDetail: data => {
    return request({
      url: `/route/station/web/evaluate/detail`,
      data,
    });
  },
};

/**
 * @description 运营管理-评论标签管理【评论标签管理】
 */
export const evaluateLabelApi = {
  /** 【评论标签管理】分页查询 */
  evaluateLabelPage: data => {
    return request({
      url: `/route/station/web/dict/page`,
      data,
    });
  },
  /** 【评论标签管理】添加评论标签 */
  evaluateLabelAdd: data => {
    return request({
      url: `/route/station/web/dict/add`,
      data,
    });
  },
  /** 【评论标签管理】编辑评论标签 */
  evaluateLabelUpdate: data => {
    return request({
      url: `/route/station/web/dict/update`,
      data,
    });
  },
  /** 【评论标签管理】删除评论标签 */
  evaluateLabelDelete: data => {
    return request({
      url: `/route/station/web/dict/delete`,
      data,
    });
  },
  /** 【评论标签管理】详情评论标签  */
  evaluateLabelDetail: data => {
    return request({
      url: `/route/station/web/dict/detail`,
      data,
    });
  },
};
/**
 * @description 运营管理-功率优先下发
 */
export const chargePowerFirst = {
  // 【优先充电】规则配置
  chargeRuleList: data => {
    return request({
      url: `/route/station/web/charge/priority/rule/page`,
      data,
    });
  },
  // 【优先充电】批量导入
  importChargeRule: data => {
    return request({
      url: '/upRoute/station/web/charge/priority/rule/batchAdd',
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      data,
    });
  },
  /** 【优先充电】添加规则 */
  chargeRuleAdd: data => {
    return request({
      url: `/route/station/web/charge/priority/rule/add`,
      data,
    });
  },
  /** 【优先充电】编辑规则 */
  chargeRuleUpdate: data => {
    return request({
      url: `/route/station/web/charge/priority/rule/update`,
      data,
    });
  },
  /** 【优先充电】删除 */
  chargeRuleDelete: data => {
    return request({
      url: `/route/station/web/charge/priority/rule/delete`,
      data,
    });
  },
  /** 【优先充电】详情 */
  chargeRuleDetail: data => {
    return request({
      url: `/route/station/web/charge/priority/rule/detail`,
      data,
    });
  },
  // 优先充电规则配置校验VIN前缀存在性
  checkVinRule: data => {
    return request({
      url: `/route/station/web/charge/priority/rule/vin/check`,
      data,
    });
  },
  // 优先级配置分页查询
  chargeRuleSort: data => {
    return request({
      url: `/route/station/web/charge/priority/page`,
      data,
    });
  },
  // 优先级配置详情
  chargeRuleSortDetail: data => {
    return request({
      url: `/route/station/web/charge/priority/detail`,
      data,
    });
  },
  // 优先级配置编辑
  chargeRuleSortEdit: data => {
    return request({
      url: `/route/station/web/charge/priority/update`,
      data,
    });
  },
  // 电站充电策略配置分页查询
  chargeRuleConfigPage: data => {
    return request({
      url: `/route/station/web/charge/priority/config/page`,
      data,
    });
  },
  chargeRuleConfigEdit: data => {
    return request({
      url: `/route/station/web/charge/priority/config/update`,
      data,
    });
  },
};
/**
 * @description 运营管理-【城市SOC、电站SOC】
 */
export const operationSoc = {
  /** 【城市SOC】分页查询 */
  citySocList: data => {
    return request({
      url: `/route/station/web/config/soc/city/page`,
      data,
    });
  },
  /** 【城市SOC】城市soc详情 */
  citySocDetail: data => {
    return request({
      url: `/route/station/web/config/soc/city/detail`,
      data,
    });
  },
  /** 【城市SOC】城市soc限制(新增) */
  cityAddCitySoc: data => {
    return request({
      url: `/route/station/web/config/soc/city/add`,
      data,
    });
  },
  /** 【城市SOC】城市soc限制(编辑) */
  cityUpdateCitySoc: data => {
    return request({
      url: `/route/station/web/config/soc/city/update`,
      data,
    });
  },
  /** 【电站SOC】-分页列表 */
  stationSocList: data => {
    return request({
      url: `/route/station/web/station/soc/page`,
      data,
    });
  },
  /** 【电站SOC】-(保存/更新)  */
  stationSocUpdate: data => {
    return request({
      url: `/route/station/web/config/soc/station/set`,
      data,
    });
  },
  /** 【电站SOC】-详情  */
  stationSocDetail: data => {
    return request({
      url: `/route/station/web/station/soc/detail`,
      data,
    });
  },
};
/**
 * 企微二维码配置
 */
export const enterpriseQRCode = {
  /**
   * 查询企微二维码配置列表
   */
  queryList: data => {
    console.log('queryList', data);
    return request({
      url: `/route/support/web/file/manage/page`,
      data,
    });
  },
  /** 删除企微二维码配置 */
  deleteQRConfig: data => {
    console.log('deleteQRConfig', data);
    return request({
      url: `/route/support/web/file/manage/delete`,
      data,
    });
  },
  /** 【查询】查询企微二维码配置城市列表 */
  cityList: data => {
    console.log('cityList', data);
    return request({
      url: `/route/support/web/file/manage/queryQrByLocation`,
      data,
    });
  },
  /** 【查询】查询企微二维码配置详情 */
  detail: data => {
    console.log('detail', data);
    return request({
      url: `/route/support/web/file/manage/detail`,
      data,
    });
  },
  /** 【新增】新增企微二维码配置 */
  addQR: data => {
    console.log('addQR', data);
    return request({
      url: `/route/support/web/file/manage/add`,
      data,
    });
  },
  /** 【修改】修改企微二维码配置 */
  updateQr: data => {
    console.log('updateQr', data);
    return request({
      url: `/route/support/web/file/manage/update`,
      data,
    });
  },
};
/**
 * 大客户定价
 */
export const bigCustomerPric = {
  /** 【分页查询】大客户定价 */
  priceConfigPage: data => {
    return request({
      url: `/poly/web/largeCustomer/price/config/page`,
      data,
    });
  },
  /** 【修改】修改大客户定价 */
  priceConfigUpdate: data => {
    return request({
      url: `/poly/web/largeCustomer/price/config/update`,
      data,
    });
  },
  /* 【查询】根据orgId查询大客户定价详细 */
  priceConfigDetail: data => {
    return request({
      url: `/poly/web/largeCustomer/price/config/detail`,
      data,
    });
  },
};

/** 订单列表 */
export const orderPage = {
  /** 实时订单分页查询 */
  chargingOrderPage: data => {
    return request({
      url: `/route/order/web/chargingOrder/page`,
      data,
    });
  },
  /** 实时订单分页详情 */
  chargingOrderInfo: data => {
    return request({
      url: `/route/order/web/chargingOrder/detail`,
      data,
    });
  },
  // 获取充电实时数据电流电压
  queryRealData: data => {
    return request({
      url: `/route/order/web/realChargingOrderData/detail`,
      data,
    });
  },
  // 充电订单-充电曲线
  queryChargeCurve: data => {
    return request({
      url: `/route/order/web/realChargingOrderData/graph`,
      data,
    });
  },
  // statistic-获取报文监控数据-分页
  queryRealMonitorData: data => {
    return request({
      url: `/route/order/web/realChargingOrderData/page`,
      data,
    });
  },
  /** BMS需求和充电机输出 */
  queryBmsRequest: data => {
    return request({
      url: `/route/device/web/queryBmsRequest`,
      data,
    });
  },
  /** 充电过程BMS信息 */
  queryBmsCharging: data => {
    return request({
      url: `/route/device/web/queryBmsCharging`,
      data,
    });
  },
  // 历史订单分页查询
  historyChargingOrderPage: data => {
    return request({
      url: `/route/order/web/historyChargingOrder/page`,
      data,
    });
  },
  /** 历史订单详情 */
  historyChargingOrderInfo: data => {
    return request({
      url: `/route/order/web/historyChargingOrder/detail`,
      data,
    });
  },
  // 异常订单分页查询
  abnormalChargingOrderPage: data => {
    return request({
      url: `/route/order/web/abnormalChargingOrder/page`,
      data,
    });
  },
  // 异常订单详情
  abnormalChargingOrderInfo: data => {
    return request({
      url: `/route/order/web/abnormalChargingOrder/detail`,
      data,
    });
  },
  // 未支付订单分页
  unPaidOrderPage: data => {
    return request({
      url: `/route/order/web/chargingUnpaidOrder/page`,
      data,
    });
  },
  /** 未支付订单详情 */
  unPaidOrderInfo: data => {
    return request({
      url: `/route/order/web/chargingUnpaidOrder/detail`,
      data,
    });
  },
  // 启动失败订单分页
  startFailOrderPage: data => {
    return request({
      url: `/route/order/web/startFailChargingOrder/page`,
      data,
    });
  },
  // 调整单-分页查询
  adjustOrderPage: data => {
    return request({
      url: `/route/order/web/adjust/page`,
      data,
    });
  },
  // 调整单-详情
  adjustOrderInfo: data => {
    return request({
      url: `/route/order/web/adjust/detail`,
      data,
    });
  },
  // 调整单号生成
  adjustOrderNo: () => {
    return request({
      method: 'GET',
      url: `/route/order/web/adjust/getAdjustNo`,
    });
  },
  // 调整单-保存
  adjustOrderSave: data => {
    return request({
      url: `/route/order/web/adjust/save`,
      data,
    });
  },
  // 查询待选的充电订单占位订单
  queryChargingOrderList: data => {
    return request({
      url: `/route/order/web/adjust/toBeSelect/detail`,
      method: 'GET',
      params: data,
    });
  },
  // 预约列表分页
  queryReserveOrderList: data => {
    return request({
      url: `/route/order/web/reserve/page`,
      data,
    });
  },
  // 占位订单分页查询
  queryOccOrderList: data => {
    return request({
      url: `/route/order/web/occupancyOrder/page`,
      data,
    });
  },
  // 占位订单详情
  queryOccOrderInfo: data => {
    return request({
      url: `/route/order/web/occupancyOrder/detail`,
      data,
    });
  },
  // 占位订单支付
  occOrderPay: data => {
    return request({
      url: `/route/order/web/occupancyOrder/pay`,
      data,
    });
  },
  /** 占位订单列表付款退款操作 */
  occOrderRefund: data => {
    return request({
      url: `/route/order/web/occ/occOrderRefund`,
      data,
    });
  },
  /** 占位订单导出 */
  placeExport: (fileName, body) => {
    return exportFile({
      url: `/route/support/web/sys/download/offlineExport`,
      data: { body },
      fileName,
    });
  },
  // 异常订单结算
  balanceAbnormalOrder: data => {
    return request({
      url: `/route/order/web/abnormalChargingOrder/balance`,
      data,
    });
  },
  // 互联电卡订单明细列表
  borderCardOrderPage: data => {
    return request({
      url: `/route/order/web/orderCard/page`,
      data,
    });
  },
  // 平安好车主订单明细列表
  pinganOrderPage: data => {
    return request({
      url: `/route/order/web/orderZdlStatement/page`,
      data,
    });
  },
};

/** 电站列表 */
export const stationPage = {
  // 报文查询 报文查询
  queryMsgList: data => {
    return request({
      url: `/route/statistics/web/protocol/page`,
      data,
    });
  },
  protocolQuery: data => {
    return request({
      url: `/route/statistics/web/protocol/query`,
      data,
    });
  },
  /** 直联电站分页查询 */
  dirFindByPage: data => {
    return request({
      url: `/route/station/web/station/page`,
      data,
    });
  },

  /** 直联电站导出 */
  dirExport: (fileName, body) => {
    return exportFile({
      url: `/route/station/direct/export`,
      data: { body },
      fileName,
    });
  },

  /** 直联电站新增 */
  dirAdd: data => {
    return request({
      url: `/route/station/web/station/add`,
      data,
    });
  },

  /** 直联电站编辑 */
  dirUpdate: data => {
    return request({
      url: `/route/station/web/station/update`,
      data,
    });
  },

  /** 直联电站详情 */
  dirDetail: data => {
    return request({
      url: `/route/station/web/station/detail`,
      data,
    });
  },
  // 充电中-策略开关
  dirStrategySwitch: data => {
    return request({
      url: `/route/station/web/station/policy/switch`,
      data,
    });
  },
  // 直联电站>详情>操作记录
  dirOperationLog: data => {
    return request({
      url: `/route/station/web/station/update/log/page`,
      data,
    });
  },

  /** 直联电站启用停用 */
  dirStatusSwitch: data => {
    return request({
      url: `/route/station/web/station/status/switch`,
      data,
    });
  },
  /** 直联电站-终端停用-终端列表 */
  disabledPileList: data => {
    return request({
      url: `/route/station/web/disableTask/pileList`,
      data,
    });
  },
  /** 直联电站-终端停用-新增停用任务 */
  addDisabledTask: data => {
    return request({
      url: `/route/station/web/disableTask/add`,
      data,
    });
  },
  /** 直联电站-终端停用-停用记录查询 */
  disabledTaskPage: data => {
    return request({
      url: `/route/station/web/disableTask/page`,
      data,
    });
  },
  /** 直联电站-终端停用-取消定时停用 */
  disabledTaskStop: data => {
    return request({
      url: `/route/station/web/disableTask/stop`,
      data,
    });
  },
  // 通过道闸网关ID查询场站列表
  listByGateId: data => {
    return request({
      url: `/route/station/web/station/listByGateId`,
      data,
    });
  },

  /** 直联电站批量导入 */
  dirImportStationInfo: (fileName, body = {}) => {
    return exportFile({
      url: `/route/station/web/importStationInfo`,
      data: { body },
      fileName,
    });
  },

  /** 互联电站分页查询 */
  intFindByPage: data => {
    return request({
      url: `/route/station/web/interconnection/findByPage`,
      data,
    });
  },

  /** 互联电站详情 */
  intDetail: data => {
    return request({
      url: `/route/station/web/detail`,
      data,
    });
  },

  /** 互联电站导出 */
  intExport: (fileName, body) => {
    return exportFile({
      url: `/route/station/interconnection/export`,
      data: { body },
      fileName,
    });
  },

  /** 互联电站启用停用 */
  intStatusSwitch: data => {
    return request({
      url: `/route/station/web/statusSwitch`,
      data,
    });
  },

  /** 站点运营配置分页查询 */
  configFindByPage: data => {
    return request({
      url: `/route/station/operate/config/findByPage`,
      data,
    });
  },

  /** 站点运营配置双枪并充配置 */
  configFindByPageAdd: data => {
    return request({
      url: `/route/station/operate/config/add`,
      data,
    });
  },

  /** findStationPrice */
  findStationPrice: data => {
    return request({
      url: `/route/station/web/station/price/strategy/current/price`,
      data,
    });
  },

  /** 互联电站同步 */
  synchronize: (params = {}) => {
    return request({
      method: 'GET',
      url: '/route/station/synchronize',
      params,
    });
  },

  /** 修改app可见 */
  updateAppShow: data => {
    return request({
      url: `/route/station/web/updateAppShow`,
      data,
    });
  },

  /** 电桩报文字典 */
  protocolDict: data => {
    return request({
      url: `/route/statistics/web/protocol/dict`,
      data,
      method: 'GET',
    });
  },
};

/** 电桩列表 */
export const directPage = {
  syncStationInfos: data => {
    return request({
      url: '/route/zdl/plat/syncStationInfos',
      data,
    });
  },
  syncBusinessPolicy: data => {
    return request({
      url: '/route/zdl/plat/syncBusinessPolicy',
      data,
    });
  },
  // 终端-分页列表
  findByPage: data => {
    return request({
      url: `/route/station/web/gun/page`,
      data,
    });
  },
  // 终端-终端类型
  terminalTypeList: data => {
    return request({
      url: `/route/station/web/gun/query/type/list`,
      data,
    });
  },
  // 终端-详情
  terminalDetail: data => {
    return request({
      url: `/route/station/web/gun/detail`,
      data,
    });
  },
  // 终端-启用/停用
  terminalStatus: data => {
    return request({
      url: `/route/station/web/gun/status/switch`,
      data,
    });
  },
  // 终端-编辑保存
  terminalSave: data => {
    return request({
      url: `/route/station/web/gun/update`,
      data,
    });
  },
  // 终端-删除
  terminalDelete: data => {
    return request({
      url: `/route/station/web/gun/delete`,
      data,
    });
  },
  // 终端-根据电站查询列表
  terminalList: data => {
    return request({
      url: `/route/station/web/gun/list`,
      data,
    });
  },

  // 直连电桩-自动生成code
  generateCode: data => {
    return request({
      url: `/route/station/web/pile/generate/code`,
      data,
    });
  },
  /** 直联电桩分页查询 */
  dirFindByPage: data => {
    return request({
      url: `/route/station/web/pile/page`,
      data,
    });
  },

  /** 校时校价 */
  setTimeAndPrice: data => {
    return request({
      url: `/route/device/web/setTimeAndPrice`,
      data,
    });
  },

  // 发布二维码
  publishQrcode: data => {
    return request({
      url: `/route/device/web/sendMarks`,
      data,
    });
  },

  /** 直联电桩导出 */
  dirExport: (fileName, body) => {
    return exportFile({
      url: `/route/station/pile/direct/export`,
      data: { body },
      fileName,
    });
  },

  /** 直联电桩新增 */
  dirAdd: data => {
    return request({
      url: `/route/station/web/pile/add`,
      data,
    });
  },

  /** 直联电桩编辑 */
  dirUpdate: data => {
    return request({
      url: `/route/station/web/pile/update`,
      data,
    });
  },

  /** 直联电桩详情 */
  dirDetail: data => {
    return request({
      url: `/route/station/web/pile/detail`,
      data,
    });
  },

  /** 直联电桩批量启停 */
  dirStartSwitch: data => {
    return request({
      url: `/route/station/web/pile/startSwitch`,
      data,
    });
  },

  /** 直联电桩删除 */
  dirDelete: data => {
    return request({
      url: `/route/station/web/pile/delete`,
      data,
    });
  },

  /** 直联电桩批量导入 */
  dirImport: data => {
    return request({
      url: `/upRoute/station/web/pile/direct/import`,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      data,
    });
  },

  /** 互联电桩导出 */
  intExport: (fileName, body) => {
    return exportFile({
      url: `/route/station/pile/interconnection/export`,
      data: { body },
      fileName,
    });
  },

  /** 互联电桩批量启停 */
  intStartSwitch: data => {
    return request({
      url: `/route/station/web/pile/startSwitch`,
      data,
    });
  },

  /** 互联电桩分页查询 */
  intFindByPage: data => {
    return request({
      url: `/route/station/web/pile/interconnection/findByPage`,
      data,
    });
  },
};

/** 品牌型号 */
export const brandModelPage = {
  // 品牌型号分页查询
  queryForPage: data => {
    return request({
      url: `/route/station/web/brand/model/page`,
      data,
    });
  },
  //

  // 品牌列表 下拉框使用  0电桩品牌1道闸品牌2车辆品牌3广告大屏 4监控设备' brandType
  brandList: (data = {}) => {
    return request({
      url: '/route/station/web/brand/list',
      data,
    });
  },

  /** 品牌型号列表 */
  brandModelList: data => {
    return request({
      url: `/route/station/web/brand/model/list`,
      data,
    });
  },

  // 品牌型号详情
  detail: (data = {}) => {
    return request({
      url: `/route/station/web/brand/model/detail`,
      data,
    });
  },

  // 品牌型号新增
  add: data => {
    return request({
      url: `/route/station/web/brand/model/add`,
      data,
    });
  },
  // 品牌型号修改
  update: data => {
    return request({
      url: `/route/station/web/brand/model/update`,
      data,
    });
  },

  /** 品牌型号导出 */
  exportPrice: (fileName, body) => {
    return exportFile({
      url: `/route/station/price/chargeStrategy/exportPrice`,
      data: { body },
      fileName,
    });
  },
};

/** 道闸管理 */
export const barrierPage = {
  // 道闸管理分页查询
  queryForPage: data => {
    return request({
      url: `/route/user/web/barrierGate/org/page`,
      data,
    });
  },
  // 道闸管理详情
  detail: (data = {}) => {
    return request({
      url: '/route/user/web/barrierGate/org/detail',
      data,
    });
  },
  gateTypeList: data => {
    return request({
      url: `/route/user/web/barrierGate/org/gateTypeList`,
      data,
    });
  },

  // 道闸管理 归属电站 列表 下拉框使用
  findStationList: data => {
    return request({
      url: `/route/station/web/station/list`,
      data,
    });
  },

  // 道闸管理 新增
  save: data => {
    return request({
      url: `/route/user/web/barrierGate/org/add`,
      data,
    });
  },
  // 道闸管理 编辑
  update: data => {
    return request({
      url: `/route/user/web/barrierGate/org/update`,
      data,
    });
  },
  // 道闸列表
  list: data => {
    return request({
      url: `/route/station/web/barrierGate/related-station-page`,
      data,
    });
  },

  // 道闸减免记录-分页列表
  parkingFreePage: data => {
    return request({
      url: `/route/order/web/parking-free/page`,
      data,
    });
  },
};

/** 数据统计 */
export const dataStatisticsServe = {
  /** 时期统计-图表模式【充电数据数中的 三个列表对应的图表都使用该接口】 */
  chargingTrendList: data => {
    return request({
      url: `/route/statistics/web/chargingData/date/chart`,
      data,
    });
  },

  /** 商户充电统计明细分页 */
  detailPageList: data => {
    return request({
      url: `/route/statistics/web/operatorStatistics/detailPageList`,
      data,
    });
  },

  /** 时期统计-分页列表查询 */
  trendDetailList: data => {
    return request({
      url: `/route/statistics/web/chargingData/date/page`,
      data,
    });
  },

  /** 电站充电统计明细 */
  stationChargingList: data => {
    return request({
      url: '/route/statistics/web/station/stationChargingList',
      data,
    });
  },

  // 充值退还明细
  rechargeAndRefundList: data => {
    return request({
      url: `/route/finance/web/account/manage/client/driver/rechargeAndRefundList`,
      data,
    });
  },

  /** 小时统计-列表和图表共用 */
  queryTrendTimeDetailList: data => {
    return request({
      url: `/route/statistics/web/chargingData/hour/list`,
      data,
    });
  },

  /** 小时统计趋势(新接口)☀ */
  queryChargingTimeTrend: data => {
    return request({
      url: `/route/statistics/web/platform/queryChargingTimeTrend`,
      data,
    });
  },

  /** 流水统计列表 */
  queryFlowMonthList: data => {
    return request({
      url: `/route/finance/web/account/flow/statistics/page`,
      data,
    });
  },

  /** 流水统计明细 */
  queryFlowMonthDetail: data => {
    return request({
      url: `/route/finance/web/account/flow/statistics/detail`,
      data,
    });
  },

  /** 电站统计-分页列表 */
  stationChargingDetailList: data => {
    return request({
      url: `/route/statistics/web/chargingData/station/page`,
      data,
    });
  },

  /** 终端统计-分页列表 */
  queryGunChargingList: data => {
    return request({
      url: `/route/statistics/web/chargingData/gun/page`,
      data,
    });
  },

  /** 商户统计-分页列表 */
  queryOperatorChargingList: data => {
    return request({
      url: `/route/statistics/web/chargingData/operator/page`,
      data,
    });
  },
};

/**
/**
 * @description 营销管理-卡券管理【平台、商户（包含优惠券、抵用卡）】【普通会员、付费会员】
 */
export const marketManage = {
  // 商城积分兑换记录-分页列表
  queryPointList: data => {
    return request({
      url: `/route/marketing/web/member/shopPoints/page`,
      data,
    });
  },
  // 商城积分兑换名称集合
  queryPointNameList: data => {
    return request({
      url: `/route/marketing/web/member/shopPoints/card-coupon-list`,
      data,
    });
  },
  /** 营销（平台/商户）卡券管理-新增 */
  add: data => {
    return request({
      url: `/route/marketing/web/cardCoupon/add`,
      data,
    });
  },
  /** 营销（平台/商户）卡券管理-卡券名称唯一性校验 */
  // unique: data => {
  //   return request({
  //     url: `/route/marketing/web/cardCoupon/cardCouponName/check`,
  //     data,
  //     notShowError: true,
  //   });
  // },
  /** 营销（平台/商户）卡券管理-详情 */
  detail: data => {
    return request({
      url: `/route/marketing/web/cardCoupon/detail`,
      data,
    });
  },
  /** 营销（平台/商户）卡券管理-作废 */
  cancel: data => {
    return request({
      url: `/route/marketing/web/cardCoupon/cancel`,
      data,
    });
  },
  /** 营销（平台/商户）卡券管理-修改库存 */
  stock: data => {
    return request({
      url: `/route/marketing/web/cardCoupon/stock/update`,
      data,
    });
  },
  /** 营销（平台/商户）卡券管理-分页列表 */
  page: data => {
    return request({
      url: `/route/marketing/web/cardCoupon/page`,
      data,
    });
  },
  /** 营销（平台/商户）卡券领取明细-分页列表 */
  detailPage: data => {
    return request({
      url: `/route/marketing/web/userCardCoupon/receive/detail/page`,
      data,
    });
  },
  /** 营销（平台/商户）卡券领取明细-作废 */
  detailCancel: data => {
    return request({
      url: `/route/marketing/web/userCardCoupon/receive/detail/cancel`,
      data,
      notShowError: true,
    });
  },
  /** 营销（平台/商户）卡券-下拉列表-for活动 */
  activityList: data => {
    return request({
      url: `/route/marketing/web/cardCoupon/list`,
      data,
    });
  },
  /** 营销（平台/商户）卡券管理-详情电站分页列表   */
  stationPage: data => {
    return request({
      url: `/route/marketing/web/cardCoupon/station/page`,
      data,
    });
  },
  /** 营销（平台/商户）卡券管理-校验库存 */
  checkStock: data => {
    return request({
      url: `/route/marketing/web/cardCoupon/stock/check`,
      data,
    });
  },
  /** 营销卡券管理-获取卡劵使用配置 */
  getConfig: data => {
    return request({
      url: `/route/marketing/web/couponUseConfig/getConfig`,
      data,
    });
  },
  /** 营销卡券管理-更新卡劵使用配置 */
  updateConfig: data => {
    return request({
      url: `/route/marketing/web/couponUseConfig/updateConfig`,
      data,
    });
  },
  /** *****************************************************【会员】Start**************************************************** */
  /** 【普通会员】列表查询 */
  memberQueryForPage: data => {
    return request({
      url: `/route/marketing/web/member/page`,
      data,
    });
  },
  /** 【普通会员、付费会员】详情 */
  memberDetails: data => {
    return request({
      url: `/poly/web/member/detail`,
      data,
    });
  },
  /** 【普通会员、付费会员】优惠券、抵用卡查询 */
  queryCardCouponByUserId: data => {
    return request({
      url: `/route/marketing/web/userCardCoupon/receive/detail/queryCardCouponByUserId`,
      data,
    });
  },
  /** 【普通会员、付费会员】成长值手动调整 */
  growthManualAdjust: data => {
    return request({
      url: `/route/marketing/web/member/growth/edit`,
      data,
    });
  },
  /** 【普通会员、付费会员】成长值规则配置 */
  saveGrowthRuleConfig: data => {
    return request({
      url: `/route/marketing/web/member/growth/add`,
      data,
    });
  },
  /** 【普通会员、付费会员】成长值规则详情 */
  showGrowthRuleConfig: data => {
    return request({
      url: `/route/marketing/web/member/growth/detail`,
      data,
    });
  },
  /** 【普通会员、付费会员】成长值流水列表 */
  queryGrowthFlowForPage: data => {
    return request({
      url: `/route/marketing/web/member/growth/page`,
      data,
    });
  },
  /** 【普通会员、付费会员】积分规则配置 */
  savePointsRuleConfig: data => {
    return request({
      url: `/route/marketing/web/member/points/add`,
      data,
    });
  },
  /** 【普通会员、付费会员】积分手动调整 */
  pointsManualAdjust: data => {
    return request({
      url: `/route/marketing/web/member/points/edit`,
      data,
    });
  },
  /** 【普通会员、付费会员】积分规则详情 */
  showPointsRuleConfig: data => {
    return request({
      url: `/route/marketing/web/member/points/detail`,
      data,
    });
  },
  /** 【普通会员、付费会员】积分流水列表 */
  queryPointsFlowForPage: data => {
    return request({
      url: `/route/marketing/web/member/points/page`,
      data,
    });
  },
  /** 【普通会员、付费会员】等级列表 */
  memberLevelList: data => {
    return request({
      url: `/route/marketing/web/member/rule/level/list`,
      data,
    });
  },
  /** 【普通会员、付费会员】等级详情查询 */
  findLevelInfoByUserId: data => {
    return request({
      url: `/route/marketing/web/member/detail`,
      data,
    });
  },
  /** 获取【普通会员、付费会员】等级规则详情 */
  findLevelInfoByLevel: data => {
    return request({
      url: `/route/marketing/web/member/rule/level/detail`,
      data,
    });
  },
  /** 【普通会员、付费会员】等级规则配置 */
  memberLevelRuleConfig: data => {
    return request({
      url: `/route/marketing/web/member/rule/level/add`,
      data,
    });
  },
  /** 【付费会员配置】列表查询 */
  paidMemberConfigList: data => {
    return request({
      // url: `/route/marketing/web/paidMemberConfig/list`,//旧接口
      url: `/route/marketing/web/paidMemberConfig/page`, // 新接口
      data,
    });
  },
  /** 【付费会员配置】新增 */
  paidMemberConfigAdd: data => {
    return request({
      url: `/route/marketing/web/paidMemberConfig/add`,
      data,
    });
  },
  /** 【付费会员配置】修改 */
  paidMemberConfigUpdate: data => {
    return request({
      url: `/route/marketing/web/paidMemberConfig/update`,
      data,
    });
  },
  /** 【付费会员配置】详情 */
  paidMemberConfigDetail: data => {
    return request({
      url: `/route/marketing/web/paidMemberConfig/detail`,
      data,
    });
  },
  /** 【付费会员配置】启用/停用 */
  paidMemberConfigEdit: data => {
    return request({
      url: `/route/marketing/web/paidMemberConfig/edit`,
      data,
    });
  },
  /** 【付费会员配置】校验付费会员配置是否启用 */
  paidMemberConfigCheck: data => {
    return request({
      url: `/route/marketing/web/paidMemberConfig/check-enabled`,
      data,
    });
  },
  /** 【付费会员】列表查询 */
  paidMemberList: data => {
    return request({
      url: `/route/marketing/web/paidMember/page`,
      data,
    });
  },
  /** 【付费会员】开通记录列表查询 */
  paidMemberOpenRecordPage: data => {
    return request({
      url: `/route/marketing/web/paidMember/openRecord/page`,
      data,
    });
  },
  /** 【付费会员】开通记录-退款 */
  paidMemberRefund: data => {
    return request({
      url: `/route/marketing/web/paidMember/refund`,
      data,
    });
  },
  /** 【付费会员】购买策略配置-列表 */
  paidMemberStrategyList: data => {
    return request({
      url: `/route/marketing/web/member/strategy/query-member-strategy-page`,
      data,
    });
  },
  /** 【付费会员】购买策略配置-查询套餐名称 */
  paidMemberConfigNameList: data => {
    return request({
      url: `/route/marketing/web/member/strategy/query-member-config-list`,
      data,
    });
  },
  /** 【付费会员】购买策略配置-绑定付费会员套餐 */
  paidMemberBindConfig: data => {
    return request({
      url: `/route/marketing/web/member/strategy/bind-paid-member-config`,
      data,
    });
  },
  /** 【付费会员】购买策略配置-解绑付费会员套餐 */
  paidMemberUnBindConfig: data => {
    return request({
      url: `/route/marketing/web/member/strategy/un-bind-paid-member-config`,
      data,
    });
  },
  /** 【付费会员】购买策略配置-删除付费会员套餐 */
  paidMemberDeleteConfig: data => {
    return request({
      url: `/route/marketing/web/member/strategy/delete-paid-member-config`,
      data,
    });
  },
  /** 【付费会员】购买策略配置-新增/编辑策略配置 */
  paidMemberEditConfig: data => {
    return request({
      url: `/upNotRoute/marketing/web/member/strategy/edit-member-strategy`,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      data,
    });
  },
  /** 【付费会员】购买策略配置-获取策略配置详情 */
  paidMemberEditConfigDetail: data => {
    return request({
      url: `/route/marketing/web/member/strategy/edit-paid-member-config-detail`,
      data,
    });
  },
  /** 【付费会员】购买策略配置-下载异常手机号excel */
  paidMemberDownloadInvalid: data => {
    return request({
      url: `/route/marketing/web/member/strategy/download-invalid`,
      data,
    });
  },
  /** 【付费会员】购买策略配置-详情-查询用户 */
  paidMemberConfigDetailPage: data => {
    return request({
      url: `/route/marketing/web/member/strategy/query-paid-member-config-detail-page`,
      data,
    });
  },
  /** **************************************************【会员】End**************************************************** */
  /** 检验卡的有效性 */
  cardCheck: data => {
    return request({
      url: `/route/marketing/web/charging/card/checkBind`,
      data,
    });
  },
  /* 可用站点配置列表 */
  availableStationIsConfig: data => {
    return request({
      url: `/route/user/web/available/station/config/page`,
      data,
    });
  },
  /* 可用电站详情--电站分页 */
  StationIsConfigDetailPage: data => {
    return request({
      url: `/poly/web/available/station/config/station/page`,
      data,
    });
  },
  /* 可用电站详情 */
  StationIsConfigDetail: data => {
    return request({
      url: `/route/user/web/available/station/config/detail`,
      data,
    });
  },
};

/** 角色管理 */
export const roleManage = {
  // 查询角色管理列表
  queryUserRoleList: data => {
    return request({
      url: `/route/user/web/role/page`,
      data,
    });
  },
  // 新增角色信息
  save: data => {
    return request({
      url: `/route/user/web/role/add`,
      data,
    });
  },
  // 修改角色信息
  update: data => {
    return request({
      url: `/route/user/web/role/update`,
      data,
    });
  },
  /** 角色管理详情 */
  detail: data => {
    return request({
      url: `/route/user/web/role/detail`,
      data,
    });
  },
  // 关联菜单树(菜单导航页获取菜单列表)
  querySupportMenuList: data => {
    return request({
      url: '/route/user/web/menu/map/list',
      data,
    });
  },
  // 菜单树形结构查询-角色绑定菜单时使用
  queryMenuTree: data => {
    return request({
      url: '/route/user/web/menu/tree/list',
      data,
    });
  },
  // 角色关联菜单
  relation: data => {
    return request({
      // url: '/route/user/web/role/relation',
      url: '/route/user/web/role/bind/account/list',
      data,
    });
  },
  /** 角色管理删除(批量) */
  batchDelete: data => {
    return request({
      url: `/route/user/web/role/delete`,
      data,
    });
  },

  /** 角色管理关联保存 */
  relationSave: data => {
    return request({
      // url: `/route/user/web/user/role/relationSave`,
      url: `/route/user/web/role/account/bind`,
      data,
    });
  },
  /** 账号新增-角色列表 */
  queryRoleListByRoleType: data => {
    return request({
      url: `/route/user/web/role/list`,
      data,
    });
  },
  // 角色管理详情-账号管理列表
  detailAccountList: data => {
    return request({
      url: `/route/user/web/role/set/account/page`,
      data,
    });
  },
};

/** 账号管理 */
export const accountManage = {
  // 查询账号管理列表
  queryUserAccountList: data => {
    return request({
      url: `/route/user/web/account/page`,
      data,
    });
  },
  // 账号管理保存
  save: data => {
    return request({
      // url: `/route/user/web/account/add`,
      url: `/route/user/web/account/add`,
      data,
    });
  },
  // 账号管理修改
  update: data => {
    return request({
      url: `/route/user/web/account/update`,
      data,
    });
  },
  /** 账号管理改密 */
  updatePass: data => {
    return request({
      url: `/route/user/web/account/password/reset`,
      data,
    });
  },
  /** 账号管理详情 */
  detail: data => {
    return request({
      url: `/route/user/web/account/detail`,
      data,
    });
  },
  /** 账号管理停用 */
  stop: data => {
    return request({
      url: `/route/user/web/account/status/switch`,
      data,
    });
  },
  /** 账号管理删除(批量) */
  batchDelete: data => {
    return request({
      url: `/route/user/web/account/delete`,
      data,
    });
  },
  /** 账号管理详情-数据权限列表（聚合） */
  detailDataPermsList: data => {
    return request({
      url: `/route/user/web/account/dataPerms/page`,
      data,
    });
  },
};

/** 操作日志 */
export const sysLog = {
  /** 系统操作日志分页列表 */
  queryLogList: data => {
    return request({
      url: `/route/support/web/log/page`,
      data,
    });
  },
  /** 系统操作日志详情 */
  queryLogDetail: data => {
    return request({
      url: `/route/support/web/log/detail`,
      data,
    });
  },
};
/** 用户配置 */
export const userCnf = {
  // 用户反馈信息分页查询
  feedbackPage: data => {
    return request({
      url: `/route/support/web/feedback/page`,
      data,
    });
  },
  // 用户反馈信息详情
  feedbackDetail: data => {
    return request({
      url: `/route/support/web/feedback/detail`,
      data,
    });
  },
  // 用户反馈信息确认
  feedbackConfirm: data => {
    return request({
      url: `/route/support/web/feedback/confirm`,
      data,
    });
  },
  // 用户反馈信息处理
  feedbackHandle: data => {
    return request({
      url: `/route/support/web/feedback/handle`,
      data,
    });
  },
};
/** 系统配置 */
export const sysCnf = {
  // 修改系统配置
  save: data => {
    return request({
      url: `/route/support/web/sys/config/update`,
      data,
    });
  },
  /** 系统配置详情 */
  detail: data => {
    return request({
      url: `/route/support/web/sys/config/detail`,
      data,
    });
  },
  /** 简化版系统配置详情 */
  simpleCnf: data => {
    return request({
      url: `/route/support/web/sys/config/simpleCnf`,
      data,
      notShowError: true,
    });
  },
  /** 用户协议模块 start */
  // 用户协议分页查询
  queryUserAgreementList: data => {
    return request({
      url: `route/support/web/agreement/page`,
      data,
    });
  },
  // 用户协议新增,修改
  saveUserAgreement: (data, isEdit) => {
    return request({
      url: !isEdit ? `route/support/web/agreement/add` : `route/support/web/agreement/update`,
      data,
    });
  },
  // 用户协议删除
  deleteUserAgreement: data => {
    return request({
      url: `route/support/web/agreement/delete`,
      data,
    });
  },
  /** 用户协议模块 end */
  /** 常见问题模块 start */
  // 常见问题分页查询
  queryCommonProblemList: data => {
    return request({
      url: `route/support/web/problem/page`,
      data,
    });
  },
  // 常见问题新增,修改
  saveCommonProblem: (data, isEdit) => {
    return request({
      url: !isEdit ? `route/support/web/problem/add` : `route/support/web/problem/update`,
      data,
    });
  },
  // 常见问题详情
  queryCommonProblemDetail: data => {
    return request({
      url: `route/support/web/problem/detail`,
      data,
    });
  },
  // 常见问题删除
  deleteCommonProblem: data => {
    return request({
      url: `route/support/web/problem/delete`,
      data,
    });
  },
  /** 常见问题模块 end */
};

/** 下载中心 */
export const sysDownload = {
  // 下载中心列表
  queryDownFileList: data => {
    return request({
      // url: `/route/support/web/sys/download/queryDownFileList`,
      url: `/route/support/web/download/center/page`,
      data,
    });
  },

  // 下载中心删除
  delete: data => {
    return request({
      url: `/route/support/web/download/center/file/delete`,
      data,
    });
  },

  // 批量下载
  batchDownload: data => {
    return request({
      url: `/route/support/web/download/center/file/download`,
      data,
    });
  },
  /** 全局离线下载 */
  offlineExport: data => {
    return request({
      // url: `/route/support/web/sys/download/offlineExport`,
      url: `/route/support/web/download/center/file/export`,
      data,
    });
  },
};

/** 消息管理 */
export const sysNotice = {
  // 查询系统消息列表
  queryNoticeList: data => {
    return request({
      url: `/route/support/web/notice/page`,
      data,
    });
  },
  // 系统消息保存
  save: data => {
    return request({
      url: `/route/support/web/notice/add`,
      data,
    });
  },
  // 系统消息详情
  detail: data => {
    return request({
      url: `/route/support/web/notice/detail`,
      data,
    });
  },
  // 系统消息详情-用户列表
  receiverPage: data => {
    return request({
      url: `/route/support/web/notice/receiver/page`,
      data,
    });
  },
  /** 系统消息推送商户信息 */
  pushOperatorList: data => {
    return request({
      url: `/route/support/web/sys/notice/pushOperatorList`,
      data,
    });
  },
  /** 系统消息删除 */
  delete: data => {
    return request({
      url: `/route/support/web/sys/notice/delete`,
      data,
    });
  },
  /** 系统消息全部已读 */
  allRead: data => {
    return request({
      url: `/route/support/web/sys/notice/allRead`,
      data,
    });
  },
  /** 根据商户查询系统消息列表 */
  queryNoticeListByOpera: data => {
    return request({
      url: `/poly/web/account/queryNoticeListByAccNo`,
      data,
    });
  },
  /** 系统消息批量下载 */
  onlineExport: data => {
    return request({
      url: `/route/support/web/sys/notice/onlineExport`,
      data,
    });
  },
  /** 推送商户下载 */
  onlineExportOpera: data => {
    return request({
      url: `/route/support/web/sys/notice/onlineExportOpera`,
      data,
    });
  },
};

/**
 * 平台价格活动-充电价格活动:
 * @type {{}}
 */
export const platformPriceActivity = {
  // 电站中的平台活动价格分页查询
  pricePage: data => {
    return request({
      url: '/route/marketing/web/activity/price/page',
      data,
    });
  },
  // 平台价格活动分页查询
  list: data => {
    return request({
      url: '/route/marketing/web/activity/platformPrice/page',
      data,
    });
  },
  // 平台价格活动新增
  add: data => {
    return request({
      url: '/route/marketing/web/activity/platformPrice/add',
      data,
    });
  },
  // 平台价格活动编辑
  edit: data => {
    return request({
      url: '/route/marketing/web/activity/platformPrice/edit',
      data,
    });
  },
  // 平台价格活动详情
  detail: data => {
    return request({
      url: '/route/marketing/web/activity/platformPrice/detail',
      data,
    });
  },
  // 平台价格活动校验活动名称唯一
  checkOnlyActivityName: data => {
    return request({
      url: '/route/marketing/web/activity/platformPrice/check/activityName',
      data,
    });
  },
  // 平台价格活动停止
  stop: data => {
    return request({
      url: '/route/marketing/web/activity/platformPrice/stop',
      data,
    });
  },
  // 根据电站ID查询进行中的活动列表
  ongoingList: data => {
    return request({
      url: '/route/marketing/web/activity/price/queryIngForPage',
      data,
    });
  },
  // 平台价格活动详情电站分页查询
  detailStations: data => {
    return request({
      url: '/route/marketing/web/activity/platformPrice/station/page',
      data,
    });
  },
  // 平台价格活动详情用户分页查询
  detailUsers: data => {
    return request({
      url: '/route/marketing/web/activity/platformPrice/user/page',
      data,
    });
  },
  // 平台价格活动详情电站、用户分组分页查询
  detailUserOrStationGroups: data => {
    return request({
      url: '/route/marketing/web/activity/platformPrice/group/page',
      data,
    });
  },
  // 平台价格活动详情商户分页查询
  detailPlatformPriceOperator: data => {
    return request({
      url: '/route/marketing/web/activity/platformPrice/operator/page',
      data,
    });
  },
  // 价格活动绑定记录分页（充电价格活动绑定车辆等）
  detailVehicleBindings: data => {
    return request({
      url: '/route/marketing/web/activity/price/bind/page',
      data,
    });
  },
};

/**
 * 商户价格活动:
 * @type {{}}
 */
export const merchantPriceActivity = {
  // 商户价格活动分页查询
  list: data => {
    return request({
      url: '/route/marketing/web/activity/operatorPrice/page',
      data,
    });
  },
  // 商户价格活动新增
  add: data => {
    return request({
      url: '/route/marketing/web/activity/operatorPrice/add',
      data,
    });
  },
  // 商户价格活动编辑
  edit: data => {
    return request({
      url: '/route/marketing/web/activity/operatorPrice/edit',
      data,
    });
  },
  // 商户价格活动详情
  detail: data => {
    return request({
      url: '/route/marketing/web/activity/operatorPrice/detail',
      data,
    });
  },
  // 商户价格活动校验活动名称唯一
  checkOnlyActivityName: data => {
    return request({
      url: '/route/marketing/web/activity/operatorPrice/check/activityName',
      data,
    });
  },
  // 商户价格活动停止
  stop: data => {
    return request({
      url: '/route/marketing/web/activity/operatorPrice/stop',
      data,
    });
  },
  // 商户价格活动详情电站分页查询
  detailStations: data => {
    return request({
      url: '/route/marketing/web/activity/operatorPrice/station/page',
      data,
    });
  },
  // 商户价格活动详情用户分页查询
  detailUsers: data => {
    return request({
      url: '/route/marketing/web/activity/operatorPrice/user/page',
      data,
    });
  },
  // 商户价格活动详情电站、用户分组分页查询
  detailUserOrStationGroups: data => {
    return request({
      url: '/route/marketing/web/activity/operatorPrice/group/page',
      data,
    });
  },
};

/**
 * 卡券活动:适用于平台卡券活动和商户卡券活动
 * @type {{}}
 */
export const couponActivity = {
  // 卡券活动列表分页查询
  list: data => {
    return request({
      url: '/route/marketing/web/activity/page',
      data,
    });
  },
  // 卡券活动停用
  stop: data => {
    return request({
      url: '/route/marketing/web/activity/stop',
      data,
    });
  },
  // 卡券活动名称判重
  checkNameOnly: data => {
    return request({
      url: '/route/marketing/web/activity/nameRepeat',
      data,
    });
  },

  // 注册领取活动新增(注册领取)
  registerActivityAdd: data => {
    return request({
      url: '/route/marketing/web/activity/register/add',
      data,
    });
  },
  // 注册领取活动编辑(注册领取)
  registerActivityUpdate: data => {
    return request({
      url: '/route/marketing/web/activity/register/update',
      data,
    });
  },
  // 注册领取活动详情(注册领取)
  registerActivityDetail: data => {
    return request({
      url: '/route/marketing/web/activity/register/detail',
      data,
    });
  },
  // 积分兑换活动新增(积分兑换)
  integralActivityAdd: data => {
    return request({
      url: '/route/marketing/web/activity/integralExchange/add',
      data,
    });
  },
  // 积分兑换活动编辑(积分兑换)
  integralActivityUpdate: data => {
    return request({
      url: '/route/marketing/web/activity/integralExchange/update',
      data,
    });
  },
  // 积分兑换活动详情(积分兑换)
  integralActivityDetail: data => {
    return request({
      url: '/route/marketing/web/activity/integralExchange/detail',
      data,
    });
  },

  // 新增/编辑(充值活动)
  rechargeActivitySave: data => {
    return request({
      url: '/route/marketing/web/cardCouponActivity/rechargeActivity/submit',
      data,
    });
  },
  // 详情(充值活动)
  rechargeActivityDetail: data => {
    return request({
      url: '/route/marketing/web/cardCouponActivity/rechargeActivity/detail',
      data,
    });
  },

  // 定向发放活动新增(定向发放活动)
  orientationActivityAdd: data => {
    return request({
      url: '/route/marketing/web/activity/directional/add',
      data,
    });
  },
  // 定向发放活动编辑(定向发放活动)
  orientationActivityUpdate: data => {
    return request({
      url: '/route/marketing/web/activity/directional/update',
      data,
    });
  },
  // 定向发放活动详情(定向发放活动)
  orientationActivityDetail: data => {
    return request({
      url: '/route/marketing/web/activity/directional/detail',
      data,
    });
  },
  // 定向发放活动-详情-用户列表(定向发放活动)
  orientationActivityUsers: data => {
    return request({
      url: '/route/marketing/web/activity/directional/user/page',
      data,
    });
  },

  // 充电领取活动新增(充电领取活动)
  chargeActivityAdd: data => {
    return request({
      url: '/route/marketing/web/activity/charge/add',
      data,
    });
  },
  // 充电领取活动编辑(充电领取活动)
  chargeActivityUpdate: data => {
    return request({
      url: '/route/marketing/web/activity/charge/update',
      data,
    });
  },
  // 充电领取活动-详情(充电领取活动)
  chargeActivityDetail: data => {
    return request({
      url: '/route/marketing/web/activity/charge/detail',
      data,
    });
  },
  // 充电领取活动-详情-活动用户列表(充电领取活动)
  chargeActivityUsers: data => {
    return request({
      url: '/route/marketing/web/activity/charge/user/page',
      data,
    });
  },
  // 充电领取活动-详情-电站列表(充电领取活动)
  chargeActivityStations: data => {
    return request({
      url: '/route/marketing/web/activity/charge/station/page',
      data,
    });
  },

  // 扫码领取活动新增(扫码领取活动)
  scanActivityAdd: data => {
    return request({
      url: '/route/marketing/web/activity/scan/add',
      data,
    });
  },
  // 扫码领取活动编辑(扫码领取活动)
  scanActivityUpdate: data => {
    return request({
      url: '/route/marketing/web/activity/scan/update',
      data,
    });
  },
  // 扫码领取活动详情(扫码领取活动)
  scanActivityDetail: data => {
    return request({
      url: '/route/marketing/web/activity/scan/detail',
      data,
    });
  },
  // 扫码领取活动用户列表(扫码领取活动)
  scanActivityUsers: data => {
    return request({
      url: '/route/marketing/web/activity/scan/user/page',
      data,
    });
  },

  // 券码兑换活动新增(券码兑换活动)
  exchangeActivityAdd: data => {
    return request({
      url: '/route/marketing/web/activity/exchange/add',
      data,
    });
  },
  // 券码兑换活动编辑(券码兑换活动)
  exchangeActivityUpdate: data => {
    return request({
      url: '/route/marketing/web/activity/exchange/update',
      data,
    });
  },
  // 券码兑换活动详情(券码兑换活动)
  exchangeActivityDetail: data => {
    return request({
      url: '/route/marketing/web/activity/exchange/detail',
      data,
    });
  },
  // 券码兑换活动用户参与（C端）
  exchangeActivityJoin: data => {
    return request({
      url: '/route/marketing/web/activity/exchange/join',
      data,
    });
  },
  // 券码兑换活动详情-用户列表(券码兑换活动)
  exchangeActivityUsers: data => {
    return request({
      url: '/route/marketing/web/activity/exchange/user/page',
      data,
    });
  },

  // 卡券活动领取记录列表分页查询
  couponReceiveRecord: data => {
    return request({
      url: '/route/marketing/web/activity/receiveRecord/page',
      data,
    });
  },
  // 批量导入用户的接口
  importUserList: data => {
    return request({
      url: `${FILE_UPLOAD_GATEWAY}user/web/charge/user/file/upload/importUserWithOutOrg`,
      data,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },

  // 拉新活动新增(老带新活动)
  InvitingActivityAdd: data => {
    return request({
      url: '/route/marketing/web/activity/inviting/add',
      data,
    });
  },
  // 拉新活动编辑(老带新活动)
  InvitingActivityUpdate: data => {
    return request({
      url: '/route/marketing/web/activity/inviting/update',
      data,
    });
  },
  // 拉新活动详情(老带新活动)
  InvitingActivityDetail: data => {
    return request({
      url: '/route/marketing/web/activity/inviting/detail',
      data,
    });
  },

  // 累充活动新增(累充活动)
  chargeSumActivityAdd: data => {
    return request({
      url: '/route/marketing/web/activity/chargeSum/add',
      data,
    });
  },
  // 累充活动编辑(累充活动)
  chargeSumActivityUpdate: data => {
    return request({
      url: '/route/marketing/web/activity/chargeSum/update',
      data,
    });
  },
  // 累充领取活动详情(累充活动)
  chargeSumActivityDetail: data => {
    return request({
      url: '/route/marketing/web/activity/chargeSum/detail',
      data,
    });
  },
  // 累充活动发放-详情-用户列表(累充活动)
  chargeSumActivityDetailUserPage: data => {
    return request({
      url: '/route/marketing/web/activity/chargeSum/user/page',
      data,
    });
  },

  // 红包活动新增(红包活动)
  redPackageActivityAdd: data => {
    return request({
      url: '/route/marketing/web/activity/redPackage/add',
      data,
    });
  },
  // 红包活动编辑(红包活动)
  redPackageActivityUpdate: data => {
    return request({
      url: '/route/marketing/web/activity/redPackage/update',
      data,
    });
  },
  // 红包活动详情(红包活动)
  redPackageActivityDetail: data => {
    return request({
      url: '/route/marketing/web/activity/redPackage/detail',
      data,
    });
  },
  // 红包活动用户列表(红包活动)
  redPackageActivityDetailUserPage: data => {
    return request({
      url: '/route/marketing/web/activity/redPackage/user/page',
      data,
    });
  },
  // 车辆认证活动新增(车辆认证活动)
  carAuthActivityAdd: data => {
    return request({
      url: '/route/marketing/web/activity/carAuth/add',
      data,
    });
  },
  // 车辆认证活动详情(车辆认证活动)
  carAuthActivityDetail: data => {
    return request({
      url: '/route/marketing/web/activity/carAuth/detail',
      data,
    });
  },
  // 车辆认证活动编辑(车辆认证活动)
  carAuthActivityUpdate: data => {
    return request({
      url: '/route/marketing/web/activity/carAuth/update',
      data,
    });
  },
};

// 商户 operatorType 1是平台商户  2是互联的
export const operatorData = {
  // 商户分页
  userOperatorPageList: data => {
    return request({
      url: '/route/station/web/operator/page',
      data,
    });
  },
  // 新增平台商户
  saveOrAdd: data => {
    return request({
      url: '/route/station/web/operator/add',
      data,
    });
  },
  // 修改平台商户
  saveOrUpdate: data => {
    return request({
      url: '/route/station/web/operator/update',
      data,
    });
  },
  // 平台商户详情
  operatorDetail: data => {
    return request({
      url: '/route/station/web/operator/detail',
      data,
    });
  },
  // 导入平台商户
  importOperator: data => {
    return request({
      url: `/upRoute/user/web/operator/importOperator`,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      data,
    });
  },
  // 导入互联商户
  importLinkOperator: data => {
    return request({
      url: `/upRoute/user/web/operator/importLinkOperator`,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      data,
    });
  },
  // 平台商户列表(下拉组件使用)
  userOperatorList: data => {
    return request({
      url: '/route/station/web/operator/list',
      data,
    });
  },
};

// 字典和区域
export const sysDict = {
  // 字典全量数据
  queryDictList: data => {
    return request({
      url: '/route/support/web/dict/all/list',
      // url: '/route/support/web/sys/dict/queryDictList',
      data,
    });
  },
  // 菜单数据
  querySupportMenuList: data => {
    return request({
      url: '/route/user/web/user/menu/querySupportMenuList',
      data,
    });
  },
  // 功能地图菜单
  queryMapMenuList: data => {
    return request({
      url: '/route/user/web/menu/map/list',
      data,
      notShowError: true,
    });
  },
  // 按钮权限集合
  queryCodePermission: data => {
    return request({
      url: '/route/user/web/menu/button/list',
      data,
      notShowError: true,
    });
  },
};

// 标签分组【用户分组】接口
export const userLabelApi = {
  // 分组查询人员
  queryForPage: data => {
    return request({
      url: '/route/marketing/web/user/group/page',
      data,
    });
  },
  // 新增人员分组
  add: data => {
    return request({
      url: '/route/marketing/web/user/group/add',
      data,
    });
  },
  // 新增人员分组
  addByCharge: data => {
    return request({
      url: '/poly/web/user/group/add',
      data,
    });
  },
  // 人员分组停用
  cancel: data => {
    return request({
      url: '/route/marketing/web/user/group/cancel',
      data,
    });
  },
  // 分组查询详情
  detail: data => {
    return request({
      url: '/route/marketing/web/user/group/detail',
      data,
    });
  },
  // 人员分组迁出 迁入
  edit: data => {
    return request({
      url: '/route/marketing/web/user/group/edit',
      data,
    });
  },
  // 人员分组批量迁入迁出
  batchMove: data => {
    return request({
      url: '/upRoute/marketing/web/user/group/batch',
      data,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
  // 迁入/迁出/新增页面批量上传人员账号
  uploadFile: data => {
    return request({
      url: '/upRoute/marketing/web/user/group/uploadFile',
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      data,
    });
  },
  // 人员分组详情--用户分页列表
  queryUserInfoForPage: data => {
    return request({
      url: '/route/marketing/web/user/group/user/page',
      data,
    });
  },
};

// 标签分组【电站分组】接口
export const stationLabelApi = {
  // 分组查询电站
  queryForPage: data => {
    return request({
      url: '/route/marketing/web/station/group/page',
      data,
    });
  },
  // 新增电站分组
  add: data => {
    return request({
      url: '/route/marketing/web/station/group/add',
      data,
    });
  },
  // 电站分组停用
  cancel: data => {
    return request({
      url: '/route/marketing/web/station/group/cancel',
      data,
    });
  },
  // 分组查询详情
  detail: data => {
    return request({
      url: '/route/marketing/web/station/group/detail',
      data,
    });
  },
  // 电站分组迁入
  edit: data => {
    return request({
      url: '/route/marketing/web/station/group/edit',
      data,
    });
  },

  // 电站分组批量迁入迁出
  batch: data => {
    return request({
      url: '/upRoute/marketing/web/station/group/batch',
      data,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
  // 分组查询电站
  stationGroupList: data => {
    return request({
      url: '/route/marketing/web/station/group/list',
      data,
    });
  },
  // 迁入/迁出/新增页面批量上传电站编码
  uploadFile: data => {
    return request({
      url: '/upRoute/marketing/web/station/group/uploadFile',
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      data,
    });
  },
  // 电站lable 电站分页查询
  queryStationForPage: data => {
    return request({
      url: '/route/marketing/web/station/group/stationPage',
      data,
    });
  },
  // 查询电站分组树
  queryStationTree: data => {
    return request({
      url: '/route/marketing/web/station/group/stationTree',
      data,
    });
  },
};

/**
 * @description 营销管理-广告管理
 */
export const adsApi = {
  // 分页查询电站
  queryForPage: data => {
    return request({
      url: '/route/marketing/web/advertisement/page',
      data,
    });
  },
  // 查询广告详情
  detail: data => {
    return request({
      url: '/route/marketing/web/advertisement/detail',
      data,
    });
  },
  // 广告详情-活动用户列表
  queryCustomerForPage: data => {
    return request({
      url: '/route/marketing/web/advertisement/customer/page',
      data,
    });
  },
  // 广告详情-用户分组列表
  queryUserGroupForPage: data => {
    return request({
      url: '/route/marketing/web/advertisement/userGroup/page',
      data,
    });
  },
  // 新增广告
  add: data => {
    return request({
      url: '/route/marketing/web/advertisement/add',
      data,
    });
  },
  // 编辑广告
  edit: data => {
    return request({
      url: '/route/marketing/web/advertisement/update',
      data,
    });
  },
  // 停用广告
  stop: data => {
    return request({
      url: '/route/marketing/web/advertisement/stop',
      data,
    });
  },
};

/** 树接口 */
export const treeUtils = {
  // 电站树
  operatorStations: data => {
    return request({
      url: '/route/station/web/station/operator/station/tree',
      data,
    });
  },
  // 电站分组
  operatorStationGroup: data => {
    return request({
      url: '/route/marketing/web/station/group/list',
      data,
    });
  },
  // 用户分组树
  operatorUsers: data => {
    return request({
      url: '/route/user/web/customer/org/type/group',
      data,
    });
  },
  // 查询主机构分组(不包含客户机构)
  operatorUsersNocustomrerOrg: data => {
    return request({
      url: '/route/user/web/customer/org/main/group',
      data,
    });
  },
  // 新的用户树
  getAllOrgInfoGroupByTypeWithOutZdl: data => {
    return request({
      url: '/route/user/web/org/getAllOrgInfoGroupByTypeWithOutZdl',
      data,
    });
  },
  // 用户分组
  operatorUserGroup: data => {
    return request({
      url: '/route/marketing/web/user/group/list',
      data,
    });
  },
  // 获取全量的省市区域信息
  getDistrict: data => {
    return request({
      url: '/route/support/web/district/all/list',
      data,
    });
  },
  // 按城市筛选电站
  findCityStationTree: data => {
    return request({
      url: '/route/station/web/station/city/station/tree',
      data,
    });
  },
  // 车辆库下拉框
  queryCarListByOrgId: data => {
    return request({
      url: '/route/user/web/car/queryCarListByOrgId',
      data,
    });
  },
};

/** 通用接口 */
export const commonUtils = {
  // 登录
  login: data => {
    return request({
      url: '/security/login',
      data,
    });
  },
  // 登出
  logout: data => {
    return request({
      url: '/security/logout',
      data,
    });
  },
  /** 获取用户登录的验证码方式及图文验证码串 */
  getLoginVerifyTypeOrImgVerifyCode: (data = {}) => {
    return request({
      url: `/security/getVerifyType`,
      data,
    });
  },
  /** 获取登录短信验证码 */
  sendVerifyCodeByAccount: data => {
    return request({
      url: `/security/sendSmsCode`,
      data,
    });
  },
};

// 上传文件
export const uploadUtils = {
  // 文件上传
  uploadFile: data => {
    return request({
      url: '/upRoute/support/web/file/upload',
      // url: '/upRoute/support/web/sys/file/uploadFile',
      data,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
  // md5文件上传
  md5UploadFile: data => {
    return request({
      url: '/upRoute/support/web/file/md5/upload',
      data,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
  // 图片上传
  uploadImg: data => {
    return request({
      url: '/upRoute/support/web/file/image/upload',
      // url: '/upRoute/support/web/sys/file/uploadImg',
      data,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
};

// 运维管理 API
export const omManagementApi = {
  // 文件上传 --远程升级使用
  uploadFile: data => {
    return request({
      url: `${UP_ROUTE_SUPPORT_PREFIX}sys/file/uploadFtp`,
      data,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
  // 远程升级
  remoteUpdate: data => {
    return request({
      url: `${OM_MANAGEMENT_PREFIX}remoteUpdate`,
      data,
    });
  },
  // 远程升级记录
  remoteUpdateRecords: data => {
    return request({
      url: `${OM_MANAGEMENT_PREFIX}remoteUpdateRecords`,
      data,
    });
  },
  // 查询新直联电桩信息
  omNewZdlInfo: data => {
    return request({
      url: `${STATION_WEB_PREFIX}pile/direct/findPileByPage`,
      data,
    });
  },
  // 告警信息 告警列表
  omAlarmInfoList: data => {
    return request({
      url: `${OM_MANAGEMENT_PREFIX}alarm/query`,
      data,
    });
  },
  //   查询短信通知规则
  // 短信告警规则列表
  // POST /device/web/alarm/querySmsRule
  // 接口ID：64087256
  // 接口地址：https://www.apifox.cn/web/project/2248392/apis/api-64087256
  querySmsRule: data => {
    return request({
      url: `${OM_MANAGEMENT_PREFIX}alarm/querySmsRule`,
      data,
    });
  },
  // 保存/编辑短信告警规则列表
  // POST /device/web/alarm/saveAlarmSmsRule
  saveAlarmSmsRule: data => {
    return request({
      url: `${OM_MANAGEMENT_PREFIX}alarm/saveAlarmSmsRule`,
      data,
    });
  },
  // 保存/编辑告警规则列表
  // POST /device/web/alarm/saveAlarmRule
  saveAlarmRule: data => {
    return request({
      url: `${OM_MANAGEMENT_PREFIX}alarm/saveAlarmRule`,
      data,
    });
  },
  //   告警规则列表
  // POST /device/web/alarm/queryAlarmRule
  // 接口ID：64084858
  // 接口地址：https://www.apifox.cn/web/project/2248392/apis/api-64084858
  queryAlarmRule: data => {
    return request({
      url: `${OM_MANAGEMENT_PREFIX}alarm/queryAlarmRule`,
      data,
    });
  },
  //   设备报文列表
  // POST /device/web/maintenance/query
  // 接口ID：64098326
  // 接口地址：https://www.apifox.cn/web/project/2248392/apis/api-64098326
  maintenanceQuery: data => {
    return request({
      url: `${RECONCILIATION_MANAGEMENT_PREFIX}protocol/queryPage`,
      data,
    });
  },
  // 告警设置列表
  // POST /statistics/web/alarm/set/queryPage
  // 接口ID：4044899
  // 接口地址：https://app.apifox.com/project/4044899
  alarmSetQueryPage: data => {
    return request({
      url: `${RECONCILIATION_MANAGEMENT_PREFIX}alarm/set/queryPage`,
      data,
    });
  },
  // 告警设置编辑
  // POST /statistics/web/alarm/set/update
  // 接口ID：4044899
  // 接口地址：https://app.apifox.com/project/4044899
  alarmSetUpdate: data => {
    return request({
      url: `${RECONCILIATION_MANAGEMENT_PREFIX}alarm/set/update`,
      data,
    });
  },
  // 告警信息列表
  // POST /statistics/web/alarm/info/queryPage
  // 接口ID：4044899
  // 接口地址：https://app.apifox.com/project/4044899
  alarmInfoQueryPage: data => {
    return request({
      url: `${RECONCILIATION_MANAGEMENT_PREFIX}alarm/info/queryPage`,
      data,
    });
  },
  // 告警统计-设备状态统计信息
  // POST /station/web/queryStatusStatistic
  // 接口ID：4044899
  // 接口地址：https://app.apifox.com/project/4044899
  alarmQueryStatusStatistic: data => {
    return request({
      url: `${STATION_MODULE_PREFIX}queryStatusStatistic`,
      data,
    });
  },
  // 告警统计-告警排行榜
  // POST /statistics/web/alarm/queryRankingList
  // 接口ID：4044899
  // 接口地址：https://app.apifox.com/project/4044899
  alarmQueryRankingList: data => {
    return request({
      url: `${RECONCILIATION_MANAGEMENT_PREFIX}alarm/queryRankingList`,
      data,
    });
  },
  // 告警统计-告警次数统计
  // POST /statistics/web/alarm/queryMonthCount
  // 接口ID：4044899
  // 接口地址：https://app.apifox.com/project/4044899
  alarmQueryMonthCount: data => {
    return request({
      url: `${RECONCILIATION_MANAGEMENT_PREFIX}alarm/queryMonthCount`,
      data,
    });
  },
  // 告警统计-告警类型统计
  // POST /statistics/web/alarm/queryTypeCount
  // 接口ID：4044899
  // 接口地址：https://app.apifox.com/project/4044899
  alarmQueryTypeCount: data => {
    return request({
      url: `${RECONCILIATION_MANAGEMENT_PREFIX}alarm/queryTypeCount`,
      data,
    });
  },
  // // 查询用户反馈
  // feedbackList: data => {
  //   return request({
  //     url: `/route/support/web/feedback/page`,
  //     data,
  //   });
  // },
  // 处理用户反馈
  replyFeedback: data => {
    return request({
      url: `${STATION_MODULE_PREFIX}feedback/deal`,
      data,
    });
  },
  // 用户反馈详情
  feedbackDetail: data => {
    return request({
      url: `${STATION_MODULE_PREFIX}feedback/queryDetail`,
      data,
    });
  },
  // 元数据管理-场站管理-列表
  findByPage: data => {
    return request({
      url: `/poly/web/station/maintainer/findByPage`,
      data,
    });
  },
  // 元数据管理-场站管理-查询运维工程师账号列表
  queryMaintainerAccountList: data => {
    return request({
      url: `/route/task/web/user/account/maintainer/queryMaintainerAccountList`,
      data,
    });
  },
  // 元数据管理-场站管理-查询电站运维人员详情（回显）
  detailStationMaintainer: data => {
    return request({
      url: `/route/task/web/detailStationMaintainer`,
      data,
    });
  },
  // 元数据管理-场站管理-批量保存电站运维人员
  saveStationMaintainer: data => {
    return request({
      url: `/route/task/web/saveStationMaintainer`,
      data,
    });
  },
  // 元数据管理-服务项管理-分页查询巡检项列表
  inspectionItemFindByPage: data => {
    return request({
      url: `/route/task/web/inspectionItem/findByPage`,
      data,
    });
  },
  // 元数据管理-服务项管理-查询巡检项类型列表
  qryInspectionItemTypeList: data => {
    return request({
      url: `/route/task/web/inspectionItem/qryInspectionItemTypeList`,
      data,
    });
  },
  // 元数据管理-服务项管理-删除巡检项
  deleteItem: data => {
    return request({
      url: `/route/task/web/inspectionItem/deleteItem`,
      data,
    });
  },
  // 元数据管理-服务项管理-保存巡检项
  saveInspectionItem: data => {
    return request({
      url: `/route/task/web/inspectionItem/saveInspectionItem`,
      data,
    });
  },
  // 元数据管理-服务项管理-批量导入巡检项
  importInspectionItemList: data => {
    return request({
      url: `${FILE_UPLOAD_GATEWAY}task/web/inspectionItem/importInspectionItemList`,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      data,
    });
  },
  // 元数据管理-服务项管理-巡检项详情
  detailInspectionItem: data => {
    return request({
      url: `/route/task/web/inspectionItem/detailInspectionItem`,
      data,
    });
  },
  // 运维巡检-【运维工单、巡检任务】-查询工单等级关联的工单配置列表(下拉框)
  findByListFromLevel: data => {
    return request({
      url: `/route/task/web/workOrder/findByListFromLevel`,
      data,
    });
  },
  // 运维巡检-运维工单-工单配置保存
  saveConf: data => {
    return request({
      url: `/route/task/web/workOrder/saveConf`,
      data,
    });
  },
  // 运维巡检-运维工单-查询工单配置
  queryConf: data => {
    return request({
      url: `/route/task/web/workOrder/queryConf`,
      data,
    });
  },
  // 运维巡检-运维工单-分页查询运维工单列表
  findWorkOrderByList: data => {
    return request({
      url: `/route/task/web/findWorkOrderByList`,
      data,
    });
  },
  // 运维巡检-运维工单-运维工单详情
  detailWorkOrder: data => {
    return request({
      url: `/route/task/web/detailWorkOrder`,
      data,
    });
  },
  // 运维巡检-运维工单-新增运维工单
  createWorkOrder: data => {
    return request({
      url: `/route/task/web/createWorkOrder`,
      data,
    });
  },
  // 运维巡检-运维工单-编辑运维工单
  editWorkOrder: data => {
    return request({
      url: `/route/task/web/editWorkOrder`,
      data,
    });
  },
  // 运维巡检-运维工单-批量关闭运维工单
  closeWorkOrder: data => {
    return request({
      url: `/route/task/web/closeWorkOrder`,
      data,
    });
  },
  // 运维巡检-运维工单-巡检项树
  findInspectionItemTree: data => {
    return request({
      url: `/route/task/web/inspectionItem/findInspectionItemTree`,
      data,
    });
  },
  // 运维巡检-巡检任务- 巡检任务列表
  findInspectionTaskByList: data => {
    return request({
      url: `/route/task/web/findInspectionTaskByList`,
      data,
    });
  },
  // 运维巡检-巡检任务- 新增巡检任务
  createInspectionTask: data => {
    return request({
      url: `/route/task/web/createInspectionTask`,
      data,
    });
  },
  // 运维巡检-巡检任务- 编辑巡检任务
  editInspectionTask: data => {
    return request({
      url: `/route/task/web/editInspectionTask`,
      data,
    });
  },
  // 运维巡检-巡检任务- 删除巡检任务
  deleteInspectionTask: data => {
    return request({
      url: `/route/task/web/deleteInspectionTask`,
      data,
    });
  },
  // 运维巡检-巡检任务-巡检任务详情
  detailInspectionTask: data => {
    return request({
      url: `/poly/web/station/operation/detailInspectionTask`,
      data,
    });
  },
  // 工单统计-工单服务统计-工单明细列表接口
  statisticsPage: data => {
    return request({
      url: `/route/task/web/workOrder/statistics/page`,
      data,
    });
  },
  // 工单统计-工单趋势统计-趋势图
  statisticsTrendList: data => {
    return request({
      url: `/route/task/web/workOrder/statistics/trendList`,
      data,
    });
  },
  // 工单统计-工单趋势统计-电站分组下拉框
  queryGroupAndStationIds: data => {
    return request({
      url: `/route/marketing/web/station/group/queryGroupAndStationIds`,
      data,
    });
  },
  // 工单统计-考核统计-运维人员考核明细列表
  statisticsExaminePage: data => {
    return request({
      url: `/route/task/web/workOrder/statistics/examine/page`,
      data,
    });
  },
};
// 工作台
export const workbench = {
  // 工作台 充电数据
  chargeData: data => {
    return request({
      url: `route/statistics/web/workbench/queryChargeData`,
      data,
    });
  },
  // 工作台 电桩监控
  monitorCount: data => {
    return request({
      url: `route/station/web/pile/monitorCount`,
      data,
    });
  },
  // 场站经营 充电趋势数据
  operationTrend: data => {
    return request({
      url: `route/statistics/web/workbench/stationOperationTrend`,
      data,
    });
  },
  // 场站经营 时段分布数据
  timeSegmentTrend: data => {
    return request({
      url: `route/statistics/web/workbench/timeSegmentTrend`,
      data,
    });
  },
  // 电桩监控分页
  monitorPage: data => {
    return request({
      url: `route/order/web/pile/monitorPage`,
      data,
    });
  },
};

// 商户对账
export const reconciliationApi = {
  // #region 运营大屏
  // 运营大屏全量数据
  queryScreenOverview: data => {
    return request({
      url: `route/statistics/web/overview/queryScreenOverview`,
      data,
    });
  },
  // 运营大屏-终端监控信息
  findStationStatistics: data => {
    return request({
      url: `/route/station/web/findStationStatistics`,
      data,
    });
  },
  // 运营大屏-电站地图
  findStationMap: data => {
    return request({
      url: `/route/station/web/findStationMap`,
      data,
    });
  },
  // 运营大屏-今日订单和今日收入(一分钟）
  queryTodayOrderInfoByOne: data => {
    return request({
      url: `/route/statistics/web/overview/queryTodayOrderInfoByOne`,
      data,
    });
  },
  // #endregion
  // 商户账单分页★
  merchantList: data => {
    return request({
      url: `/route/statistics/web/operatorBill/page`,
      data,
    });
  },
  // 商户账单结算(新接口)★
  settlement: data => {
    return request({
      url: `/route/statistics/web/operatorBill/settle`,
      data,
    });
  },

  // 商户详情页的账单明细
  merchantDetailList: data => {
    return request({
      url: `/route/statistics/web/operatorBill/detail/page`,
      data,
    });
  },
  // 互联互通列表
  interconnectedList: data => {
    return request({
      url: `/route/statistics/web/linkBill/page`,
      data,
    });
  },
  // 互联互通账单分页★
  interconnectedSettle: data => {
    return request({
      url: `/route/statistics/web/linkBill/settle`,
      data,
    });
  },
  // 互联互通账单detail分页★ 明细
  linkBillDetailPageList: data => {
    return request({
      url: `/route/statistics/web/linkBill/detail/page`,
      data,
    });
  },
  //  平台收支账单列表平台账单列表查询

  queryPlatformBillForPage: data => {
    return request({
      url: `/route/statistics/web/platformOrderBill/page`,
      data,
    });
  },
  // 平台收支账单总计查询
  queryPlatformBillTotalByTime: data => {
    return request({
      url: `/route/statistics/web/platformOrderBill/queryByTime`,
      data,
    });
  },
  //   平台账单明细列表查询
  queryPlatformBillDetailForPage: data => {
    return request({
      url: `/route/statistics/web/platformOrderBill/detail/page`,
      data,
    });
  },
  //  占位账单列表查询
  placeholderBillList: data => {
    return request({
      url: `/route/statistics/web/parking/page`,
      data,
    });
  },
  //   占位账单明细列表查询
  placeholderBillingDetailsList: data => {
    return request({
      url: `/route/statistics/web/parking/detail/page`,
      data,
    });
  },
  //   主机构账单
  queryMainFundBillForPage: data => {
    return request({
      url: `/route/finance/web/fund/bill/page`,
      data,
    });
  },
  //   子机构账单
  queryChildFundBillForPage: data => {
    return request({
      url: `/route/finance/web/fund/bill/childPage`,
      data,
    });
  },
  //   主子机构账单流
  queryOrgBillFlowForPage: data => {
    return request({
      url: `/route/finance/web/fund/bill/flow/list`,
      data,
    });
  },
  //   机构流水头部详情
  getOrgHeader: data => {
    return request({
      url: `/route/finance/web/fund/bill/header/detail`,
      data,
    });
  },

  // 所有流量方名称 流量机构下拉框
  queryAllZdlUser: data => {
    return request({
      url: `/route/user/web/customer/org/flow/list`,
      data,
    });
  },
  // 付费会员收支账单列表查询
  queryPayMemberBillForPage: data => {
    return request({
      url: `/route/marketing/web/member/bill/page`,
      data,
    });
  },
  // 付费会员收支账单详情列表查询
  queryPayMemberBillDetailForPage: data => {
    return request({
      url: `/route/marketing/web/member/bill/detail/page`,
      data,
    });
  },
};

/** APP升级管理 */
export const upgradeManage = {
  /** 查询列表 */
  queryUpgradeList: data => {
    return request({
      url: '/route/support/web/upgrade/page',
      data,
    });
  },
  addUpgrade: data => {
    return request({
      url: '/route/support/web/upgrade/add',
      data,
    });
  },
  // 启用版本升级
  editUpgrade: data => {
    return request({
      url: '/route/support/web/upgrade/update',
      data,
    });
  },
  uploadFile: config => {
    return request({
      url: '/upRoute/support/web/file/upload',
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      ...config,
    });
  },
  getOssConfig: () => {
    return request({
      method: 'GET',
      url: '/route/support/web/sys/file/getSignature',
    });
  },
};

// 场外辅助设备
export const auxiliaryDevice = {
  // 查询场站监控照片列表-历史
  queryParkMonitorList: data => {
    return request({
      url: '/poly/web/monitor/operate/pageParkingPictureHistory',
      data,
    });
  },
  // 查询监控设备审计日志列表
  AuditLogList: data => {
    return request({
      url: '/poly/web/monitor/log/pageAuditLog',
      data,
    });
  },

  // 广告大屏分页
  getAdScreenPage: data => {
    return request({
      url: `/route/station/web/advertScreen/list`,
      data,
    });
  },
  // 广告大屏详情
  getAdScreenDetail: data => {
    return request({
      url: `/route/station/web/advertScreen/detail`,
      data,
    });
  },
  // 广告大屏新增
  addAdScreen: data => {
    return request({
      url: `/route/station/web/advertScreen/add`,
      data,
    });
  },
  // 广告大屏修改
  editAdScreen: data => {
    return request({
      url: `/route/station/web/advertScreen/update`,
      data,
    });
  },
  // 广告大屏删除
  delAdScreen: data => {
    return request({
      url: `/route/station/web/advertScreen/delete`,
      data,
    });
  },
};

// 实时监控
export const monitorManage = {
  // 充电桩监控列表
  getPileMonitor: data => {
    return request({
      url: `${STATION_WEB_PREFIX}pile/monitor/page`,
      data,
    });
  },

  // 广告屏监控列表
  getAdScreenMonitor: data => {
    return request({
      url: `${STATION_WEB_PREFIX}advertScreen/realTimeMonitor/list`,
      data,
    });
  },

  // 广告屏监控运维配置-保存
  setAdScreenConfig: data => {
    return request({
      url: `${STATION_WEB_PREFIX}advertScreen/realTimeMonitor/setConfig`,
      data,
    });
  },

  // 广告屏监控运维配置-删除
  deleteAdScreen: data => {
    return request({
      url: `${STATION_WEB_PREFIX}advertScreen/delete`,
      data,
    });
  },

  // 查询品牌列表
  getBrandList: data => {
    return request({
      url: `${STATION_WEB_PREFIX}brand/list`,
      data,
    });
  },

  // 获取充电站列表
  getStationList: data => {
    return request({
      url: `${STATION_WEB_PREFIX}station/list`,
      data,
    });
  },

  // 根据电站查询终端
  getGunByStation: data => {
    return request({
      url: `${STATION_WEB_PREFIX}gun/list`,
      data,
    });
  },
};

export const parkSpaceMonitorManage = {
  // 查询监控设备列表
  getMonitorPage: data => {
    return request({
      url: `${POLY_MONITOR_PREFIX}manage/page`,
      data,
    });
  },

  // 新增监控设备信息
  addMonitor: data => {
    return request({
      url: `${POLY_MONITOR_PREFIX}manage/add`,
      data,
    });
  },

  // 批量新增监控设备信息
  addMonitorBatch: data => {
    return request({
      url: `${POLY_MONITOR_PREFIX}manage/addBatch`,
      data,
    });
  },

  // 编辑监控设备信息
  updateMonitor: data => {
    return request({
      url: `${POLY_MONITOR_PREFIX}manage/update`,
      data,
    });
  },

  // 查询监控设备信息
  getMonitorDetail: data => {
    return request({
      url: `${POLY_MONITOR_PREFIX}manage/detail`,
      data,
    });
  },

  // 删除监控设备信息
  deleteMonitor: data => {
    return request({
      url: `${POLY_MONITOR_PREFIX}manage/delete`,
      data,
    });
  },

  // 查询场站监控设备列表
  getMonitorOperate: data => {
    return request({
      url: `${POLY_MONITOR_PREFIX}operate/page`,
      data,
    });
  },
  // 查询场站监控设备坐标设置信息
  getMonitorOperateDetail: data => {
    return request({
      url: `/poly/web/monitor/operate/detailCoordinatesInfo`,
      data,
    });
  },
  // 平台配置坐标设置
  setCoordinates: data => {
    return request({
      url: `/poly/web/monitor/command/setCoordinatesUpdate`,
      data,
    });
  },
  // 修改场站监控设备坐标设置信息
  updateMonitorOperate: data => {
    return request({
      url: `${POLY_MONITOR_PREFIX}operate/update`,
      data,
    });
  },

  // 运维控制
  // 1：重启、2：休眠、3：唤醒、4：重启地锁、5：休眠地锁、6：唤醒地锁、7：停止地锁鸣叫
  setRemoteControl: data => {
    return request({
      url: `${POLY_MONITOR_PREFIX}command/setRemoteControl`,
      data,
    });
  },

  // 控制拍照
  setCaptureControl: data => {
    return request({
      url: `${POLY_MONITOR_PREFIX}command/setCaptureControl`,
      data,
    });
  },
  // 查询指令下发的确认结果
  getCommandResult: data => {
    return request({
      url: `/poly/web/monitor/command/getCommandConfirm`,
      data,
    });
  },
  // 获取抓拍照片
  getCapturePhoto: data => {
    return request({
      url: `${POLY_MONITOR_PREFIX}command/getCapturePhoto`,
      data,
    });
  },

  // 控制地锁升降 lockState：地锁命令 1: 升起、2: 降下
  setLockState: data => {
    return request({
      url: `${POLY_MONITOR_PREFIX}command/setLockState`,
      data,
    });
  },
  // 设置地锁降下
  setLockDown: data => {
    return request({
      url: `/poly/web/monitor/command/setLockDown`,
      data,
    });
  },

  // 枪的急停状态恢复
  setGunStop: data => {
    return request({
      url: `/route/device/web/gun/status/reset`,
      data,
    });
  },
};

// 升级包管理
export const pileUpgradeManage = {
  getPackageList: data => {
    return request({
      url: '/route/device/web/ota/package/page',
      data,
    });
  },
  addPackage: data => {
    return request({
      url: '/route/device/web/ota/package/add',
      data,
    });
  },
  updatePackage: data => {
    return request({
      url: '/route/device/web/ota/package/update',
      data,
    });
  },
  detailPackage: data => {
    return request({
      url: '/route/device/web/ota/package/detail',
      data,
    });
  },
  getAllPackageList: data => {
    return request({
      url: '/route/device/web/ota/package/list',
      data,
    });
  },
  getTaskList: data => {
    return request({
      url: '/route/device/web/ota/task/page',
      data,
    });
  },
  addTask: data => {
    return request({
      url: '/route/device/web/ota/task/add',
      data,
    });
  },
  detailTask: data => {
    return request({
      url: '/route/device/web/ota/task/detail',
      data,
    });
  },
  deleteTask: data => {
    return request({
      url: '/route/device/web/ota/task/delete',
      data,
    });
  },
  importPackage: data => {
    return request({
      url: '/upRoute/station/web/pile/ota/import',
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      data,
    });
  },
  restartTask: data => {
    return request({
      url: '/route/device/web/ota/task/start',
      data,
    });
  },
  taskDetailList: data => {
    return request({
      url: '/route/device/web/ota/task/pile/page',
      data,
    });
  },
};

/** 车辆品牌管理 */
export const vehicleBrand = {
  /** 查询品牌列表 */
  queryBrandList: data => {
    return request({
      url: '/route/support/web/vehicle/brand/query-brand-list',
      data,
    });
  },
};
